// import React, { useState, useEffect } from "react";
// import { MapContainer, TileLayer, Marker, Popup } from "react-leaflet";
// import "leaflet/dist/leaflet.css";
// import L from "leaflet";
// import { FaRegHeart, FaHeart } from "react-icons/fa";
// import { BiRupee } from "react-icons/bi";
// import { AiOutlineInfo } from "react-icons/ai";
// import axios from "axios";
// import { useLocation } from "react-router-dom";
// import { Link } from "react-router-dom";
// import { RiArrowDropDownLine } from "react-icons/ri";
// import { MdOutlineNavigateBefore, MdOutlineNavigateNext } from "react-icons/md";
// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// import { faShareNodes, faUserCircle } from "@fortawesome/free-solid-svg-icons";
// import { AiOutlineUser } from "react-icons/ai";
// import { MdOutlineBedroomParent } from "react-icons/md";
// import { FaMapMarkerAlt } from "react-icons/fa";
// import { BiArea } from "react-icons/bi";
// import { FaRupeeSign } from "react-icons/fa";
// import { faChair } from "@fortawesome/free-solid-svg-icons";
// import { PiShareNetworkLight } from "react-icons/pi";
// import { ShareNetwork } from "@phosphor-icons/react";
// import { PiCubeFocus } from "react-icons/pi";
// import ShareModal from "../containers/ShareModal";
// import Slider from "react-slick";
// import { Heart } from "lucide-react";
// import { toast } from "react-toastify";
// import { useCity } from "./SearchContext";
// import Login1 from "../auth/Login1";
// import SignUp1 from "../auth/SignUp1";
// import { FaWhatsapp, FaPhone } from "react-icons/fa";
// import ContactDetails from "../containers/ContactDetails";

// const AdvisorDashboard = () => {
//   const [hoveredPropertyId, setHoveredPropertyId] = useState(null);
//   const [squareFtDropdownOpen, setSquareFtDropdownOpen] = useState(false);
//   const location = useLocation();
//   const [properties, setProperties] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);
//   const [isFavorited, setIsFavorited] = useState(false);
//   const queryParams = new URLSearchParams(location.search);
//   const label = queryParams.get("label");
//   const [search, setSearch] = useState("");
//   const [propertyType, setPropertyType] = useState("");
//   const [bhkType, setBhkType] = useState("");
//   const [furnishedStatus, setFurnishedStatus] = useState("");
//   const [minSquareFt, setMinSquareFt] = useState("");
//   const [maxSquareFt, setMaxSquareFt] = useState("");
//   const [filtersApplied, setFiltersApplied] = useState(false);
//   const [activePropertyId, setActivePropertyId] = useState(null);
//   const [currentShareUrl, setCurrentShareUrl] = useState("");
//   const [isShareModalOpen, setIsShareModalOpen] = useState(false);
//   const [activeShareId, setActiveShareId] = useState(null);
//   const accessToken = sessionStorage.getItem("accessToken");
//   const [activeIndexes, setActiveIndexes] = useState({});
//   const { searchCity, setSearchCity } = useCity();
//   const [currentPage, setCurrentPage] = useState(1);
//   const [totalPages, setTotalPages] = useState(1);
//   const itemsPerPage = 10;
//   const [priceDropdownOpen, setPriceDropdownOpen] = useState(false);
//   const [minPrice, setMinPrice] = useState("");
//   const [maxPrice, setMaxPrice] = useState("");
//   const [currentIndex, setCurrentIndex] = useState(0);
//   const [propertyImages, setPropertyImages] = useState([]);
//   // Modal open states
//   const [postedBy, setPostedBy] = useState("");
//   const [isLoginModalOpen, setIsLoginModalOpen] = useState(false);
//   const [isSignUpModalOpen, setIsSignUpModalOpen] = useState(false);
//   const toggleSquareFtDropdown = () => {
//     setSquareFtDropdownOpen((prev) => !prev);
//   };

//   const [constructionStatus, setConstructionStatus] = useState([]);
//   const [constructionOpen, setConstructionOpen] = useState(false);
//   const [amenitiesList, setAmenitiesList] = useState([]);
//   const [selectedAmenities, setSelectedAmenities] = useState([]);
//   const [amenitiesOpen, setAmenitiesOpen] = useState(false);
//   const [bathrooms, setBathrooms] = useState("");
//   const [facing, setFacing] = useState("");
//   const [withPhoto, setWithPhoto] = useState("");
//   const [withVideos, setWithVideos] = useState("");
//   const [areaIn, setAreaIn] = useState("sq.ft");
//   const [sharingType, setSharingType] = useState([]);
//   const [availableFrom, setAvailableFrom] = useState([]);

//   const [sharingTypeOpen, setSharingTypeOpen] = useState(false);
//   const [availableFromOpen, setAvailableFromOpen] = useState(false);
//   const [availableFor, setAvailableFor] = useState([]);
//   const [availableForOpen, setAvailableForOpen] = useState(false);
//   const [capacity, setCapacity] = useState([]);
//   const [capacityOpen, setCapacityOpen] = useState(false);
//   const [investmentOptions, setInvestmentOptions] = useState([]);
//   const [purchaseType, setPurchaseType] = useState("");
//   const [investmentOpen, setInvestmentOpen] = useState(false);

//   const [plotLandTypes, setPlotLandTypes] = useState([]);
//   const [plotLandOpen, setPlotLandOpen] = useState(false);

//   const [officeType, setOfficeType] = useState([]);
//   const [retailType, setRetailType] = useState([]);
//   const [otherCommercialType, setOtherCommercialType] = useState([]);

//   const [officeTypeOpen, setOfficeTypeOpen] = useState(false);
//   const [retailTypeOpen, setRetailTypeOpen] = useState(false);
//   const [otherCommercialOpen, setOtherCommercialOpen] = useState(false);

//   const [selectedProperty, setSelectedProperty] = useState(null);
//   const [isContactModalOpen, setIsContactModalOpen] = useState(false);

//   const [buildingType, setBuildingType] = useState("");
//   const [propertyType2, setPropertyType2] = useState([]);
//   const [mode, setMode] = useState("search");
//   const [propertyTypeOpen, setPropertyTypeOpen] = useState(false);

//   const [freeViewCount, setFreeViewCount] = useState(0);
//   const [paidViewCount, setPaidViewCount] = useState(0);
//   const [showUpgradePrompt, setShowUpgradePrompt] = useState(false);

//   const officeTypeOptions = [
//     "Ready to move office space",
//     "Bare shell office space",
//     "Co-working office space",
//   ];

//   const retailTypeOptions = [
//     "Mall",
//     "Commercial Project",
//     "Residential Project",
//     "Retail Complex/Building",
//     "Market/High Street",
//   ];

//   const otherCommercialOptions = [
//     "Factory",
//     "Ware House",
//     "Hotel Resorts",
//     "Guest-House/Banquet-Halls",
//     "Cold Storage",
//     "Manufacturing",
//     "Others",
//   ];

//   const commercialPropertyOptions = [
//     "Ready to move office space",
//     "Bare shell office space",
//     "Ware House",
//     "Factory",
//     "Hotel/Resorts",
//     "Others",
//     "Plot/Land",
//     "Cold Storage",
//     "Manufacturing",
//     "Guest-House/Banquet-Halls",
//     "Retail", // important
//   ];

//   const plotLandOptions = [
//     "Commercial Land/Inst. Land",
//     "Industrial Lands/Plots",
//     "Agricultural/Farm Land",
//   ];

//   const investmentOptionsList = [
//     "Pre-leased Spaces",
//     "Restaurants",
//     "SCO Plots",
//     "Business Center",
//     "Food Court",
//     "Multiplex",
//     "Co-working",
//   ];

//   const purchaseTypeOptions = ["Resale", "New bookings"];

//   const priceOptions = [
//     500000, // 5 Lakh
//     1000000, // 10 Lakh
//     1500000, // 15 Lakh
//     2000000, // 20 Lakh
//     2500000, // 25 Lakh
//     3000000, // 30 Lakh
//     3500000, // 35 Lakh
//     4000000, // 40 Lakh
//     4500000, // 45 Lakh
//     5000000, // 50 Lakh
//     5500000, // 55 Lakh
//     6000000, // 60 Lakh
//     6500000, // 65 Lakh
//     7000000, // 70 Lakh
//     7500000, // 75 Lakh
//     8000000, // 80 Lakh
//     8500000, // 85 Lakh
//     9000000, // 90 Lakh
//     9500000, // 95 Lakh

//     10000000, // 1 Crore
//     12500000, // 1.25 Crore
//     15000000, // 1.5 Crore
//     17500000, // 1.75 Crore
//     20000000, // 2 Crore
//     25000000, // 2.5 Crore
//     30000000, // 3 Crore
//     40000000, // 4 Crore
//     50000000, // 5 Crore
//     75000000, // 7.5 Crore

//     100000000, // 10 Crore
//     150000000, // 15 Crore
//     200000000, // 20 Crore
//     250000000, // 25 Crore
//     300000000, // 30 Crore
//     400000000, // 40 Crore
//     500000000, // 50 Crore
//     600000000, // 60 Crore
//     700000000, // 70 Crore
//     750000000, // 75 Crore
//     900000000, // 90 Crore

//     1000000000, // 100 Crore
//     1500000000, // 150 Crore
//     2000000000, // 200 Crore
//     2500000000, // 250 Crore
//     3000000000, // 300 Crore
//     4000000000, // 400 Crore
//     5000000000, // 500 Crore
//     6000000000, // 600 Crore
//     7000000000, // 700 Crore
//     7500000000, // 750 Crore
//     9000000000, // 900 Crore

//     10000000000, // 1000 Crore (10 Billion)
//   ];

//   const areaUnits = [
//     "sq.ft",
//     "sq.yards",
//     "sq.m",
//     "acre",
//     "marla",
//     "cents",
//     "bigha",
//     "kottah",
//     "kanal",
//     "grounds",
//     "ares",
//     "biswa",
//     "guntha",
//     "aankadam",
//     "hectares",
//     "rood",
//     "chataks",
//     "perch",
//   ];

//   const DEFAULT_CENTER = [18.5204, 73.8567];
//   const getMapCenter = () => {
//     if (
//       properties.length > 0 &&
//       properties[0].latitude &&
//       properties[0].longitude
//     ) {
//       return [properties[0].latitude, properties[0].longitude];
//     }
//     return DEFAULT_CENTER;
//   };

//   const formatPriceMinMax = (value) => {
//     const num = Number(value);
//     if (num >= 10000000)
//       return (num / 10000000).toFixed(1).replace(/\.0$/, "") + " Cr";
//     if (num >= 100000)
//       return (num / 100000).toFixed(1).replace(/\.0$/, "") + " L";
//     if (num >= 1000) return (num / 1000).toFixed(1).replace(/\.0$/, "") + " K";
//     return num;
//   };

//   //  Add to favorites
//   const addToFavorites = async (PropertyId) => {
//     if (!accessToken) {
//       toast.error("You must be logged in to perform this action");
//       return;
//     }

//     try {
//       const response = await axios.post(
//         `${process.env.REACT_APP_API_URL}/cust_api/add_to_favorite`,
//         {
//           user_id: accessToken,
//           property_id: PropertyId,
//         },
//       );
//       loadProperties();
//     } catch (error) {
//       loadProperties();
//       console.error("Error adding property to favorites:", error);
//     }
//   };

//   //  Remove to favorites
//   const removeFromFavorites = async (favoriteId) => {
//     const formData = new FormData();
//     formData.append("favorite_id", favoriteId);

//     try {
//       const response = await axios.delete(
//         `${process.env.REACT_APP_API_URL}/cust_api/remove_from_favorite`,
//         { data: formData },
//       );

//       if (response.data.status === 1) {
//         loadProperties();
//       } else {
//         loadProperties();
//         console.error("Failed to remove:", response.data.message);
//       }
//     } catch (error) {
//       console.error("Error unfavoriting:", error);
//     }
//   };

//   const togglePriceDropdown = () => {
//     setPriceDropdownOpen((prev) => !prev);
//   };

//   const handlePrev = () => {
//     setCurrentIndex((prev) =>
//       prev === 0 ? propertyImages.length - 1 : prev - 1,
//     );
//   };

//   const handleNext = () => {
//     setCurrentIndex((prev) =>
//       prev === propertyImages.length - 1 ? 0 : prev + 1,
//     );
//   };

//   const fetchAmenities = async () => {
//     try {
//       const formData = new FormData();

//       const response = await axios.post(
//         "https://api.nowaybroker.com/cust_api/get_amenities",
//         formData,
//       );

//       if (response.data.status === 1) {
//         setAmenitiesList(response.data.data);
//       }
//     } catch (error) {
//       console.log("Amenities fetch failed", error);
//     }
//   };

//   const toggleAmenity = (id) => {
//     const value = String(id);

//     setSelectedAmenities((prev) =>
//       prev.includes(value)
//         ? prev.filter((item) => item !== value)
//         : [...prev, value],
//     );
//   };

//   const togglePropertyType = (type) => {
//     if (propertyType === "Commercial Lease" && buildingType === "Commercial") {
//       // Single select behavior
//       setPropertyType2([type]);
//     } else {
//       // Existing multi-select behavior
//       setPropertyType2((prev) =>
//         prev.includes(type)
//           ? prev.filter((item) => item !== type)
//           : [...prev, type],
//       );
//     }
//   };

//   const incrementBathrooms = () => {
//     setBathrooms((prev) => {
//       const current = parseInt(prev) || 0;
//       return current < 20 ? String(current + 1) : prev;
//     });
//   };

//   const decrementBathrooms = () => {
//     setBathrooms((prev) => {
//       const current = parseInt(prev) || 0;
//       return current > 0 ? String(current - 1) : "";
//     });
//   };

//   const handleBathroomInput = (e) => {
//     const value = e.target.value;

//     if (value === "") {
//       setBathrooms("");
//       return;
//     }

//     const numericValue = parseInt(value);

//     if (!isNaN(numericValue) && numericValue >= 0 && numericValue <= 20) {
//       setBathrooms(String(numericValue));
//     }
//   };

//   useEffect(() => {
//     if (label) {
//       setPostedBy(label);
//     }
//   }, [label]);

//   useEffect(() => {
//     fetchAmenities();
//   }, []);

//   useEffect(() => {
//     setError(null);
//     const style = document.createElement("style");
//     style.innerHTML = `
//       .leaflet-popup-content-wrapper {
//         margin-bottom: 50px !important;
//         padding: 0 !important;
//       }
      
//       .leaflet-popup-content {
//         margin: 0 !important;
//         padding: 0 !important;
//       }

//       .leaflet-container a.leaflet-popup-close-button {
//         z-index: 1000;
//         top: 5px !important;
//         left: 10px;
//         border: none;
//         background-color: rgba(0, 0, 0, 0.6);
//         color: white;
//         cursor: pointer;
//         border-radius: 50%;
//       }

//       .leaflet-container a.leaflet-popup-close-button:hover {
//         background-color: rgba(0, 0, 0, 0.9);
//         color: white;
//       }

//       .leaflet-container .leaflet-popup-heart-button {
//         z-index: 1000;
//         position: absolute;
//         top: 5px;
//         right: 10px; /* Adjust the position from right */
//         width: 26px;
//         height: 24px;
//         border: none;
//         background-color: rgba(0, 0, 0, 0.6);
//         color: white;
//         cursor: pointer;
//         border-radius: 20%;
//         display: flex;
//         align-items: center;
//         justify-content: center;
//         padding: 1px;
//       }

//       .leaflet-container .leaflet-popup-heart-button:hover {
//         background-color: rgba(0, 0, 0, 0.9);
//         color: white;
//       }

//       .custom-marker.active .marker-wrapper .price-tooltip{
//          background-color: green;
//       }
      
//       /* Wrapper for marker */
//       .marker-wrapper {
//         position: relative;
//         display: flex;
//         justify-content: center;
//         align-items: center;
//       }

//       /* Tooltip-like price box */
// .price-tooltip {
//   background: white;
//   color: black; /* Ensure the text color is black */
//   padding: 8px 12px;
//   border-radius: 18px;
//   font-weight: bold; /* Make the text bold */
//   font-size: 1.1rem; /* Increased font size */
//   box-shadow: 0 2px 6px rgba(0, 0, 0, 0.15);
//   position: relative;
//   text-align: center;
//   white-space: nowrap;
//   z-index: 10;
// }


//       .price-tooltip:hover {
//         background-color: gray; /* Change to gray on hover */
//         color: white; /* Optional: Change text color for better contrast */
//       }

//       /* Pointer (triangle below the box) */
//       .price-tooltip .pointer {
//         position: absolute;
//         bottom: -8px;
//         left: 50%;
//         transform: translateX(-50%);
//         width: 0;
//         height: 0;
//         border-left: 8px solid transparent;
//         border-right: 8px solid transparent;
//         border-top: 8px solid white;
//         background-color: lightgray;
//       }
      

//       /* Adjust the marker size */
//       .custom-marker {
//         display: flex;
//         align-items: center;
//         justify-content: center;
//       }
//       input[type="number"]::-webkit-outer-spin-button,
//       input[type="number"]::-webkit-inner-spin-button {
//         -webkit-appearance: none;
//         margin: 0;
//       }

//       input[type="number"] {
//         -moz-appearance: textfield;
//       }

//       .custom-button {
//         font-family: "Arial", sans-serif;
//         font-size: 1.5rem;
//         background-color: #fff;
//         padding: 0.5rem;
//         text-align: center;
//         cursor: pointer;
//       }

//       .custom-button:hover {
//         background-color: #f0f0f0;
//         color: #333;
//       }
//     `;
//     document.head.appendChild(style);
//   }, []);

//   const loadProperties = async () => {
//     try {
//       setLoading(true);

//       const formData = new FormData();

//       // =========================
//       // BASIC REQUIRED PARAMS
//       // =========================

//       formData.append("page", currentPage);
//       formData.append("page_size", itemsPerPage);

//       if (postedBy || label) {
//         formData.append("user_type", postedBy || label);
//       }

//       if (accessToken) {
//         formData.append("customer_id", accessToken);
//       }

//       // =========================
//       // CITY
//       // =========================

//       const cityFromSession = sessionStorage.getItem("cityName");

//       const cityToUse =
//         searchCity && searchCity.trim() !== ""
//           ? searchCity.trim()
//           : cityFromSession || "";

//       if (cityToUse) {
//         formData.append("city_name", cityToUse);
//       }

//       // =========================
//       // FILTERS
//       // =========================

//       if (filtersApplied) {
//         // =========================
//         // SEARCH
//         // =========================

//         if (search) {
//           formData.append("search_keyword", search);
//         }

//         // =========================
//         // BUILDING TYPE
//         // =========================

//         if (buildingType) {
//           formData.append("building_type", buildingType);
//         }

//         // =========================
//         // PROPERTY CATEGORY
//         // =========================

//         if (propertyType) {
//           const apiPropertyCategory =
//             propertyType === "Commercial Buy"
//               ? "Buy"
//               : propertyType === "Commercial Lease"
//                 ? "Rent"
//                 : propertyType;

//           formData.append("property_category_type", apiPropertyCategory);
//         }

//         // =========================
//         // COMMERCIAL LEASE MAPPING
//         // =========================

//         if (
//           propertyType === "Commercial Lease" &&
//           buildingType === "Commercial"
//         ) {
//           const mapped = mapCommercialLeaseTypes({
//             propertyType2,
//             officeType,
//             retailType,
//             otherCommercialType,
//             plotLandTypes,
//           });

//           if (mapped.property_type.length > 0) {
//             formData.append("property_type", mapped.property_type.join(","));
//           }

//           if (mapped.office_type.length > 0) {
//             formData.append("office_type", mapped.office_type.join(","));
//           }

//           if (mapped.sub_sub_property_type.length > 0) {
//             formData.append(
//               "sub_sub_property_type",
//               mapped.sub_sub_property_type.join(","),
//             );
//           }
//         }

//         // =========================
//         // COMMERCIAL BUY MAPPING
//         // =========================
//         else if (propertyType === "Commercial Buy") {
//           const mapped = mapCommercialTypes(propertyType2);

//           if (mapped.property_type.length > 0) {
//             formData.append("property_type", mapped.property_type.join(","));
//           }

//           if (mapped.office_type.length > 0) {
//             formData.append("office_type", mapped.office_type.join(","));
//           }

//           if (mapped.sub_sub_property_type.length > 0) {
//             formData.append(
//               "sub_sub_property_type",
//               mapped.sub_sub_property_type.join(","),
//             );
//           }
//         }

//         // =========================
//         // NORMAL PROPERTY TYPES
//         // =========================
//         else {
//           if (propertyType2.length > 0) {
//             formData.append("property_type", propertyType2.join(","));
//           }
//         }

//         // =========================
//         // BASIC FILTERS
//         // =========================

//         if (bhkType) {
//           formData.append("bhk_type", bhkType);
//         }

//         if (furnishedStatus) {
//           formData.append("furnished_type", furnishedStatus);
//         }

//         if (minPrice) {
//           formData.append("min_price", minPrice);
//         }

//         if (maxPrice) {
//           formData.append("max_price", maxPrice);
//         }

//         if (minSquareFt) {
//           formData.append("min_area", minSquareFt);
//         }

//         if (maxSquareFt) {
//           formData.append("max_area", maxSquareFt);
//         }

//         if ((minSquareFt || maxSquareFt) && areaIn) {
//           formData.append("area_in", areaIn);
//         }

//         // =========================
//         // CONSTRUCTION STATUS
//         // =========================

//         if (constructionStatus.length > 0) {
//           formData.append("construction_status", constructionStatus.join(","));
//         }

//         // =========================
//         // AMENITIES
//         // =========================

//         if (selectedAmenities.length > 0) {
//           formData.append("amenities", selectedAmenities.join(","));
//         }

//         // =========================
//         // EXTRA FILTERS
//         // =========================

//         if (bathrooms) {
//           formData.append("number_of_minimum_bathrooms", bathrooms);
//         }

//         if (facing) {
//           formData.append("facing", facing);
//         }

//         if (withPhoto) {
//           formData.append("with_photo", withPhoto);
//         }

//         if (withVideos) {
//           formData.append("with_videos", withVideos);
//         }

//         // =========================
//         // RENT / PG FILTERS
//         // =========================

//         if (availableFor.length > 0) {
//           formData.append("available_for", availableFor.join(","));
//         }

//         if (sharingType.length > 0) {
//           formData.append("sharing_type", sharingType.join(","));
//         }

//         if (availableFrom.length > 0) {
//           formData.append("available_from", availableFrom.join(","));
//         }

//         if (capacity.length > 0) {
//           formData.append("available_beds", mapCapacityToBeds(capacity));
//         }

//         // =========================
//         // COMMERCIAL BUY FILTERS
//         // =========================

//         if (investmentOptions.length > 0) {
//           formData.append("investment_options", investmentOptions.join(","));
//         }

//         if (purchaseType) {
//           formData.append("purchase_type", purchaseType);
//         }
//       }

//       // =========================
//       // API CALL
//       // =========================

//       const response = await axios.post(
//         `${process.env.REACT_APP_API_URL}/cust_api/filter_property`,
//         formData,
//         {
//           headers: {
//             "Content-Type": "multipart/form-data",
//           },
//         },
//       );

//       // =========================
//       // SUCCESS
//       // =========================

//       if (response.status === 200 && response.data.status === 1) {
//         setProperties(response.data.data || []);
//         setTotalPages(response.data.total_pages || 1);
//         setError(null);
//       }

//       // =========================
//       // NO DATA
//       // =========================
//       else {
//         setProperties([]);
//         setTotalPages(1);
//         setError("No properties available");
//       }
//     } catch (error) {
//       console.error("Load Properties Error:", error);

//       setProperties([]);
//       setTotalPages(1);
//       setError("Failed to load properties.");
//     } finally {
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     loadProperties();
//   }, [label, currentPage, searchCity, filtersApplied]);

//   const formatPrice = (price) => {
//     if (!price) return "";

//     price = parseInt(price);

//     const formatNumber = (num) => {
//       return num % 1 === 0 ? num.toFixed(0) : num.toFixed(2); // no decimals if whole number
//     };

//     if (price >= 10000000) {
//       return `₹ ${formatNumber(price / 10000000)} Cr`; // Crores
//     } else if (price >= 100000) {
//       return `₹ ${formatNumber(price / 100000)} L`; // Lakhs
//     } else if (price >= 1000) {
//       return `₹ ${formatNumber(price / 1000)} K`; // Thousands
//     } else {
//       return `₹ ${price}`;
//     }
//   };

//   const createCustomIcon = (property, isActive = false) => {
//     // Decide what to display
//     let displayValue = "";
//     if (property.property_category_type === "Buy" && property.property_price) {
//       displayValue = formatPrice(property.property_price);
//     } else if (property.property_category_type === "Rent" && property.rent) {
//       displayValue = formatPrice(property.rent);
//     }

//     return L.divIcon({
//       className: `custom-marker ${isActive ? "active" : ""}`,
//       html: `
//         <div class="marker-wrapper">
//           <div class="price-tooltip">
//             ${displayValue}
//             <div class="pointer"></div>
//           </div>
//         </div>
//       `,
//       iconSize: [50, 60],
//       iconAnchor: [25, 60],
//     });
//   };

//   // Handle button click
//   const handleButtonClick = async () => {
//     if (filtersApplied) {
//       // Reset all filters
//       setPropertyType("");
//       setBuildingType("");
//       setBhkType("");
//       setFurnishedStatus("");
//       setMinPrice("");
//       setMaxPrice("");
//       setMinSquareFt("");
//       setMaxSquareFt("");
//       setPostedBy("");
//       setConstructionStatus([]);
//       setSelectedAmenities([]);
//       setBathrooms("");
//       setFacing("");
//       setWithPhoto("");
//       setWithVideos("");
//       setPropertyType2([]);
//       setAvailableFor([]);
//       setSharingType([]);
//       setAvailableFrom([]);
//       setCapacity([]);
//       setInvestmentOptions([]);
//       setPurchaseType("");

//       setPlotLandTypes([]);

//       // Close dropdowns
//       setPriceDropdownOpen(false);
//       setSquareFtDropdownOpen(false);
//       setAmenitiesOpen(false);

//       // Reset mode
//       setFiltersApplied(false);
//       setMode("search");
//       setCurrentPage(1);

//       loadProperties();
//     } else {
//       setFiltersApplied(true);
//       setMode("filter");
//       setCurrentPage(1);

//       loadProperties();
//       setAreaIn("sq.ft");
//     }
//   };

//   const toggleFavorite = async (propertyId) => {
//     const userId = sessionStorage.getItem("accessToken");
//     if (!userId) {
//       alert("Please log in to save properties to your favorites.");
//       return;
//     }

//     const data = { user_id: userId, property_id: propertyId };

//     try {
//       if (!isFavorited) {
//         await axios.post(
//           `${process.env.REACT_APP_API_URL}/cust_api/add_to_favorite`,
//           data,
//         );
//         setIsFavorited(true); // Set heart to filled state
//         alert("Property has been saved to your favorites!");
//       } else {
//         await axios.post(
//           `${process.env.REACT_APP_API_URL}/cust_api/remove_from_favorite`,
//           data,
//         );
//         setIsFavorited(false); // Set heart to unfilled state
//         alert("Property has been removed from your favorites!");
//       }
//     } catch (error) {
//       // console.error("Error toggling favorite status:", error);
//       alert("Failed to update the property. Please try again.");
//     }
//   };

//   useEffect(() => {
//     window.scrollTo({ top: 0, behavior: "smooth" });
//   }, [currentPage]);

//   const openShareModal1 = (url, propertyId) => {
//     setCurrentShareUrl(url);
//     setActiveShareId(propertyId);
//     setIsShareModalOpen(true);
//   };

//   const handleCloseShareModal = () => {
//     setIsShareModalOpen(false);
//     setActiveShareId(null);
//   };

//   const handleSaveSearch = async () => {
//     if (!accessToken) {
//       toast.error("Please login first to save search.");
//       setIsLoginModalOpen(true);
//       return;
//     }

//     try {
//       const propertyIds = [];
//       const propertyNames = [];
//       const propertyCategories = [];
//       const buildingTypes = [];

//       properties.forEach((prop) => {
//         propertyIds.push(prop._id || "");
//         propertyNames.push(prop.property_name || "");
//         propertyCategories.push(prop.property_category_type || "");
//         buildingTypes.push(prop.building_type || "");
//       });

//       const formData = new FormData();

//       // =========================
//       // USER + PROPERTY
//       // =========================
//       formData.append("user_id", accessToken);
//       formData.append("property_id", propertyIds.join("|"));
//       formData.append("property_name", propertyNames.join("|"));
//       formData.append("property_category_type", propertyCategories.join("|"));
//       formData.append("building_type", buildingTypes.join("|"));

//       // =========================
//       // SEARCH INFO
//       // =========================
//       const cityFromSession = sessionStorage.getItem("cityName");

//       formData.append("city_name", searchCity || cityFromSession || "");
//       formData.append("search_keyword", search || "");

//       // =========================
//       // COMMERCIAL MAPPING (CRITICAL)
//       // =========================
//       if (
//         propertyType === "Commercial Lease" &&
//         buildingType === "Commercial"
//       ) {
//         const mapped = mapCommercialLeaseTypes({
//           propertyType2,
//           officeType,
//           retailType,
//           otherCommercialType,
//           plotLandTypes,
//         });

//         if (mapped.property_type.length)
//           formData.append("property_type", mapped.property_type.join(","));

//         if (mapped.office_type.length)
//           formData.append("office_type", mapped.office_type.join(","));

//         if (mapped.sub_sub_property_type.length)
//           formData.append(
//             "sub_sub_property_type",
//             mapped.sub_sub_property_type.join(","),
//           );
//       } else if (propertyType === "Commercial Buy") {
//         const mapped = mapCommercialTypes(propertyType2);

//         if (mapped.property_type.length)
//           formData.append("property_type", mapped.property_type.join(","));

//         if (mapped.office_type.length)
//           formData.append("office_type", mapped.office_type.join(","));

//         if (mapped.sub_sub_property_type.length)
//           formData.append(
//             "sub_sub_property_type",
//             mapped.sub_sub_property_type.join(","),
//           );
//       } else {
//         if (propertyType2.length > 0) {
//           formData.append("property_type", propertyType2.join(","));
//         }
//       }

//       // =========================
//       // BASIC FILTERS
//       // =========================
//       if (bhkType) formData.append("bhk_type", bhkType);
//       if (furnishedStatus) formData.append("furnished_type", furnishedStatus);
//       if (minPrice) formData.append("min_price", minPrice);
//       if (maxPrice) formData.append("max_price", maxPrice);
//       if (minSquareFt) formData.append("min_area", minSquareFt);
//       if (maxSquareFt) formData.append("max_area", maxSquareFt);
//       if (areaIn) formData.append("area_in", areaIn);
//       if (postedBy) formData.append("user_type", postedBy);

//       // =========================
//       // MULTI SELECT
//       // =========================
//       if (constructionStatus.length > 0) {
//         formData.append("construction_status", constructionStatus.join(","));
//       }

//       if (selectedAmenities.length > 0) {
//         formData.append("amenities", selectedAmenities.join(","));
//       }

//       // =========================
//       // EXTRA FILTERS
//       // =========================
//       if (bathrooms) formData.append("no_of_bathrooms", bathrooms);
//       if (facing) formData.append("facing", facing);
//       if (withPhoto) formData.append("with_photo", withPhoto);
//       if (withVideos) formData.append("with_videos", withVideos);

//       if (availableFor.length > 0) {
//         formData.append("available_for", availableFor.join(","));
//       }

//       if (sharingType.length > 0) {
//         formData.append("sharing_type", sharingType.join(","));
//       }

//       if (availableFrom.length > 0) {
//         formData.append("available_from", availableFrom.join(","));
//       }

//       if (capacity.length > 0) {
//         formData.append("available_beds", mapCapacityToBeds(capacity));
//       }

//       if (investmentOptions.length > 0) {
//         formData.append("investment_options", investmentOptions.join(","));
//       }

//       if (purchaseType) {
//         formData.append("purchase_type", purchaseType);
//       }

//       // =========================
//       // API CALL
//       // =========================
//       const response = await fetch(
//         `${process.env.REACT_APP_API_URL}/cust_api/add_save_search_property`,
//         {
//           method: "POST",
//           body: formData,
//         },
//       );

//       const result = await response.json();

//       if (response.ok && result.status === 1) {
//         toast.success("Search saved successfully!");
//       } else {
//         toast.error(result.message || "Failed to save search.");
//       }
//     } catch (error) {
//       console.error("Save Search Error:", error);
//       toast.error("Something went wrong.");
//     }
//   };

//   const shouldShowFacingFilter = () => {
//     return propertyType2.includes("Plot/Land");
//   };

//   const getFilteredPropertyTypes = () => {
//     if (propertyType === "Commercial Lease" && buildingType === "Commercial") {
//       return [
//         "Office Space",
//         "Retail Shops/Showrooms",
//         "Other Commercial spaces",
//         "Plot/Land",
//       ];
//     }
//     if (propertyType === "Commercial Buy" || buildingType === "Commercial") {
//       return commercialPropertyOptions;
//     }

//     if (propertyType === "Buy") {
//       return [
//         "Flat/Apartment",
//         "Home/Villa",
//         "Service Apartment",
//         "Farmhouse",
//         "Plot/Land",
//         "Builder Floor",
//         "1RK/Studio Apartment",
//       ];
//     }

//     if (propertyType === "Rent") {
//       return [
//         "Flat/Apartment",
//         "Builder Floor",
//         "1RK/Studio Apartment",
//         "Independent House/Villa",
//         "Service Apartment",
//         "Farmhouse",
//       ];
//     }

//     if (propertyType === "PG/Co-living") {
//       return [
//         "Flat/Apartment",
//         "Builder Floor",
//         "1RK/Studio Apartment",
//         "Independent House/Villa",
//         "Service Apartment",
//       ];
//     }

//     // Default
//     return [
//       "Apartment",
//       "Flat/Apartment",
//       "Builder Floor",
//       "Independent House/Villa",
//       "Independent/Builder Floor",
//       "1RK/Studio Apartment",
//       "Service Apartment",
//       "Farmhouse",
//       "Office",
//       "Retail",
//       "Plot/Land",
//       "Storage",
//       "Industry",
//       "Hospitality",
//       "Other",
//       "Home/Villa",
//     ];
//   };

//   const toggleAvailableFor = (value) => {
//     setAvailableFor((prev) =>
//       prev.includes(value)
//         ? prev.filter((item) => item !== value)
//         : [...prev, value],
//     );
//   };

//   const getAvailableForOptions = () => {
//     if (propertyType === "Rent") {
//       return ["Family", "Single Women", "Single Men", "Company Guest House"];
//     }

//     if (propertyType === "PG/Co-living") {
//       return ["Boys", "Girls", "Working"];
//     }

//     return [];
//   };

//   const toggleSharingType = (value) => {
//     setSharingType((prev) =>
//       prev.includes(value)
//         ? prev.filter((item) => item !== value)
//         : [...prev, value],
//     );
//   };

//   const toggleAvailableFrom = (value) => {
//     setAvailableFrom((prev) =>
//       prev.includes(value)
//         ? prev.filter((item) => item !== value)
//         : [...prev, value],
//     );
//   };

//   const toggleCapacity = (value) => {
//     setCapacity((prev) =>
//       prev.includes(value)
//         ? prev.filter((item) => item !== value)
//         : [...prev, value],
//     );
//   };

//   const mapCapacityToBeds = (capacityArr) => {
//     const mapping = {
//       "1-2 guest": "1-2",
//       "2-4 guest": "2-4",
//       "4-10 guest": "4-10",
//       "10+ guest": "10+",
//     };

//     return capacityArr.map((item) => mapping[item]).join(",");
//   };

//   const toggleInvestmentOption = (value) => {
//     setInvestmentOptions((prev) =>
//       prev.includes(value)
//         ? prev.filter((item) => item !== value)
//         : [...prev, value],
//     );
//   };

//   const togglePlotLandType = (value) => {
//     setPlotLandTypes((prev) =>
//       prev.includes(value)
//         ? prev.filter((item) => item !== value)
//         : [...prev, value],
//     );
//   };

//   const toggleConstructionStatus = (value) => {
//     setConstructionStatus((prev) =>
//       prev.includes(value)
//         ? prev.filter((item) => item !== value)
//         : [...prev, value],
//     );
//   };

//   useEffect(() => {
//     if (!propertyType2.includes("Plot/Land")) {
//       setPlotLandTypes([]);
//     }
//   }, [propertyType2]);

//   const mapCommercialTypes = (selectedTypes) => {
//     const property_type = [];
//     const office_type = [];
//     const sub_sub_property_type = [];

//     selectedTypes.forEach((item) => {
//       const val = item.trim();

//       if (val === "Plot/Land") {
//         property_type.push("Plot/Land");

//         if (plotLandTypes.length > 0) {
//           office_type.push(...plotLandTypes);
//         }
//       } else if (val === "Retail") {
//         property_type.push("Retail");
//       } else if (val === "Others") {
//         sub_sub_property_type.push("Others");
//       } else {
//         office_type.push(val);
//       }
//     });

//     return { property_type, office_type, sub_sub_property_type };
//   };

//   const mapCommercialLeaseTypes = ({
//     propertyType2,
//     officeType,
//     retailType,
//     otherCommercialType,
//     plotLandTypes,
//   }) => {
//     let property_type = [];
//     let office_type = [];
//     let sub_sub_property_type = [];

//     propertyType2.forEach((type) => {
//       //  OFFICE SPACE
//       if (type === "Office Space") {
//         property_type.push("Office");
//         office_type.push(...officeType);
//       }

//       //  RETAIL
//       else if (type === "Retail Shops/Showrooms") {
//         property_type.push("Retail");
//         sub_sub_property_type.push(...retailType);
//       }

//       //  OTHER COMMERCIAL
//       else if (type === "Other Commercial spaces") {
//         otherCommercialType.forEach((item) => {
//           if (item === "Others") {
//             sub_sub_property_type.push("Others");
//           } else {
//             office_type.push(item);
//           }
//         });
//       }

//       //  PLOT/LAND (same as before)
//       else if (type === "Plot/Land") {
//         property_type.push("Plot/Land");

//         // send plot sub-types in office_type (same as Buy logic)
//         if (plotLandTypes.length > 0) {
//           office_type.push(...plotLandTypes);
//         }
//       }
//     });

//     return {
//       property_type,
//       office_type,
//       sub_sub_property_type,
//       plotLandTypes,
//     };
//   };

//   const getPaginationRange = () => {
//     const range = [];
//     const groupSize = 3;

//     const groupStart =
//       Math.floor((currentPage - 1) / groupSize) * groupSize + 1;
//     const groupEnd = Math.min(groupStart + groupSize - 1, totalPages);

//     for (let i = groupStart; i <= groupEnd; i++) {
//       range.push(i);
//     }

//     if (groupEnd < totalPages) {
//       range.push("...");
//       range.push(totalPages);
//     }

//     return range;
//   };

//   const checkPostLimits = async () => {
//     try {
//       const profileForm = new FormData();
//       profileForm.append("user_id", accessToken);

//       const profileResponse = await axios.post(
//         `${process.env.REACT_APP_API_URL}/cust_api/get_profile`,
//         profileForm,
//         {
//           headers: {
//             "Content-Type": "multipart/form-data",
//           },
//         },
//       );

//       const countData = profileResponse?.data?.count_data;

//       if (countData) {
//         setFreeViewCount(countData.free_view_count || 0);
//         setPaidViewCount(countData.paid_view_count || 0);
//       }
//     } catch (error) {
//       console.error("Error checking post limits:", error);
//     }
//   };

//   useEffect(() => {
//     if (accessToken) {
//       checkPostLimits();
//     }
//   }, [accessToken]);

//   const handleAddCount = async (updatedCount) => {
//     try {
//       const addCountFormData = new FormData();

//       if (freeViewCount > 0) {
//         addCountFormData.append("free_view_count", -1);
//       } else {
//         addCountFormData.append("paid_view_count", -1);
//       }

//       addCountFormData.append("user_id", accessToken);

//       const response = await fetch(
//         `${process.env.REACT_APP_API_URL}/cust_api/add_count`,
//         {
//           method: "POST",
//           body: addCountFormData,
//         },
//       );

//       const data = await response.json();

//       if (response.ok) {
//         checkPostLimits();
//       } else {
//         console.error("Failed to update count:", data.message);
//       }
//     } catch (error) {
//       console.error("API error:", error);
//     }
//   };

//   const handleContactClick = async (property) => {
//     if (!accessToken) {
//       setIsLoginModalOpen(true);
//       return;
//     }

//     setSelectedProperty(property);

//     // CASE 1 -> FREE VIEWS AVAILABLE
//     if (freeViewCount > 0) {
//       await handleAddCount(freeViewCount);

//       setShowUpgradePrompt(false);
//       setIsContactModalOpen(true);
//       return;
//     }

//     // CASE 2 -> PAID VIEWS AVAILABLE
//     if (paidViewCount > 0) {
//       await handleAddCount(paidViewCount);

//       setShowUpgradePrompt(false);
//       setIsContactModalOpen(true);
//       return;
//     }

//     // CASE 3 -> NO COUNTS LEFT
//     setShowUpgradePrompt(true);
//     setIsContactModalOpen(true);
//   };

//   return (
//     <>
//       <div className="flex flex-col p-1 space-y-4 sm:p-6 bg-rose-50 rounded-xl">
//         {/* Search and Filter Section */}
//         <div className="flex flex-col flex-wrap items-center justify-center gap-4 md:flex-row md:items-center">
//           {/* Left Side - Search Input (Optional Placeholder) */}

//           {/* Right Side Fields */}
//           <div className="flex flex-wrap w-full gap-2 mt-2 md:w-auto">
//             {/* Property Category Dropdown */}
//             <div className="w-full sm:w-[200px]">
//               <select
//                 value={propertyType}
//                 onChange={(e) => {
//                   const val = e.target.value;

//                   setPropertyType(val);

//                   setPropertyType2([]);
//                   setOfficeType([]);
//                   setRetailType([]);
//                   setOtherCommercialType([]);
//                   setPlotLandTypes([]);

//                   // Auto-set building type
//                   if (val === "Commercial Buy" || val === "Commercial Lease") {
//                     setBuildingType("Commercial");
//                   } else {
//                     setBuildingType("");
//                   }
//                 }}
//                 className="w-full h-16 p-2 border-2 border-gray-300 rounded-md"
//               >
//                 <option value="">Property Category</option>
//                 <option value="Buy">Buy</option>
//                 <option value="Rent">Rent</option>
//                 <option value="Commercial Buy">Commercial Buy</option>
//                 <option value="Commercial Lease">Commercial Lease</option>
//                 <option value="PG/Co-living">PG/Co-living</option>
//               </select>
//             </div>

//             {/* Building Type Dropdown */}
//             <div className="w-full sm:w-[180px]">
//               <select
//                 value={buildingType}
//                 onChange={(e) => setBuildingType(e.target.value)}
//                 disabled={
//                   propertyType === "Commercial Buy" ||
//                   propertyType === "Commercial Lease"
//                 }
//                 className="w-full h-16 p-2 border-2 border-gray-300 rounded-md focus:outline-none hover:bg-gray-300"
//               >
//                 <option value="">Building Type</option>
//                 <option value="Commercial">Commercial</option>
//                 <option value="Residential">Residential</option>
//               </select>
//             </div>

//             <div className="relative w-full sm:w-[260px]">
//               <button
//                 type="button"
//                 onClick={() => setPropertyTypeOpen(!propertyTypeOpen)}
//                 className="flex items-center justify-between w-full h-16 px-4 bg-white border-2 border-gray-300 rounded-md"
//               >
//                 <span className="truncate text-left">
//                   {propertyType2.length > 0
//                     ? propertyType2.join(", ")
//                     : "Property Type"}
//                 </span>

//                 <RiArrowDropDownLine className="text-2xl" />
//               </button>

//               {propertyTypeOpen && (
//                 <div className="absolute left-0 z-50 w-full mt-2 bg-white border rounded-md shadow-lg max-h-72 overflow-y-auto">
//                   {getFilteredPropertyTypes().map((type) => (
//                     <label
//                       key={type}
//                       className="flex items-center gap-3 px-3 py-2 cursor-pointer hover:bg-gray-100"
//                     >
//                       <input
//                         type={
//                           propertyType === "Commercial Lease" &&
//                           buildingType === "Commercial"
//                             ? "radio"
//                             : "checkbox"
//                         }
//                         name="propertyType"
//                         checked={propertyType2.includes(type)}
//                         onChange={() => togglePropertyType(type)}
//                       />

//                       <span>{type}</span>
//                     </label>
//                   ))}

//                   <div className="sticky bottom-0 flex gap-2 p-2 bg-white border-t">
//                     <button
//                       onClick={() => setPropertyType2([])}
//                       className="w-1/2 py-2 border rounded-md"
//                     >
//                       Clear
//                     </button>

//                     <button
//                       onClick={() => setPropertyTypeOpen(false)}
//                       className="w-1/2 py-2 text-white bg-rose-500 rounded-md"
//                     >
//                       Done
//                     </button>
//                   </div>
//                 </div>
//               )}
//             </div>

//             {/* Budget Dropdown */}
//             <div className="relative w-full sm:w-48 md:w-60">
//               <button
//                 onClick={togglePriceDropdown}
//                 className="flex items-center justify-between w-full h-16 px-4 bg-white border-2 border-gray-300 rounded-md focus:outline-none hover:bg-gray-300"
//               >
//                 <span>
//                   {minPrice && maxPrice
//                     ? `${formatPriceMinMax(minPrice)} - ${formatPriceMinMax(maxPrice)}`
//                     : minPrice
//                       ? `Above ${formatPriceMinMax(minPrice)}`
//                       : maxPrice
//                         ? `Below ${formatPriceMinMax(maxPrice)}`
//                         : "Budget"}
//                 </span>

//                 <RiArrowDropDownLine className="text-2xl" />
//               </button>

//               {priceDropdownOpen && (
//                 <div className="absolute left-0 mt-2 w-full p-4 bg-white border-2 border-gray-300 rounded-md shadow-lg z-[20]">
//                   <div className="flex flex-col gap-2">
//                     <label className="text-sm text-gray-600">Min Price</label>
//                     <select
//                       value={minPrice}
//                       onChange={(e) => setMinPrice(e.target.value)}
//                       className="p-2 border-2 border-gray-300 rounded-md focus:outline-none"
//                     >
//                       <option value="">Min</option>
//                       {priceOptions
//                         .filter((price) => !maxPrice || price < maxPrice) // enforce < Max
//                         .map((price) => (
//                           <option key={price} value={price}>
//                             {formatPriceMinMax(price)}
//                           </option>
//                         ))}
//                     </select>

//                     <label className="text-sm text-gray-600">Max Price</label>
//                     <select
//                       value={maxPrice}
//                       onChange={(e) => setMaxPrice(e.target.value)}
//                       className="p-2 border-2 border-gray-300 rounded-md focus:outline-none"
//                     >
//                       <option value="">Max</option>
//                       {priceOptions
//                         .filter((price) => !minPrice || price > minPrice) // enforce > Min
//                         .map((price) => (
//                           <option key={price} value={price}>
//                             {formatPriceMinMax(price)}
//                           </option>
//                         ))}
//                     </select>
//                   </div>
//                 </div>
//               )}
//             </div>

//             {/* Furnished Status Dropdown */}
//             <div className="w-full sm:w-[200px]">
//               <select
//                 value={furnishedStatus}
//                 onChange={(e) => setFurnishedStatus(e.target.value)}
//                 className="w-full h-16 p-2 border-2 border-gray-300 rounded-md focus:outline-none hover:bg-gray-300"
//               >
//                 <option value="">Select Furnished</option>
//                 <option value="Furnished">Furnished</option>
//                 <option value="Semi-Furnished">Semi-Furnished</option>
//                 <option value="Unfurnished">Unfurnished</option>
//               </select>
//             </div>

//             {/* BHK Type Dropdown */}
//             <div className="w-full sm:w-[150px]">
//               <select
//                 value={bhkType}
//                 onChange={(e) => setBhkType(e.target.value)}
//                 className="w-full h-16 p-2 border-2 border-gray-300 rounded-md focus:outline-none hover:bg-gray-300"
//               >
//                 <option value="">Select BHK</option>
//                 <option value="Studio">Studio</option>
//                 <option value="1 RK">1 RK</option>
//                 <option value="1 BHK">1 BHK</option>
//                 <option value="1.5 BHK">1.5 BHK</option>
//                 <option value="2 BHK">2 BHK</option>
//                 <option value="2.5 BHK">2.5 BHK</option>
//                 <option value="3 BHK">3 BHK</option>
//                 <option value="3.5 BHK">3.5 BHK</option>
//                 <option value="4 BHK">4 BHK</option>
//                 <option value="5 BHK">5 BHK</option>
//                 <option value="6+ BHK">6+ BHK</option>
//               </select>
//             </div>

//             {/* Posted By Dropdown */}
//             <div className="w-full sm:w-[180px]">
//               <select
//                 value={postedBy}
//                 onChange={(e) => setPostedBy(e.target.value)}
//                 className="w-full h-16 p-2 border-2 border-gray-300 rounded-md focus:outline-none hover:bg-gray-300"
//               >
//                 <option value="">Posted By</option>
//                 <option value="Owner">Owner</option>
//                 <option value="Builder">Builder</option>
//               </select>
//             </div>

//             {/* Construction Status */}
//             <div className="relative w-full sm:w-[260px]">
//               <button
//                 type="button"
//                 onClick={() => setConstructionOpen(!constructionOpen)}
//                 className="flex items-center justify-between w-full h-16 px-4 bg-white border-2 border-gray-300 rounded-md"
//               >
//                 <span className="truncate text-left">
//                   {constructionStatus.length > 0
//                     ? constructionStatus.join(", ")
//                     : "Construction Status"}
//                 </span>

//                 <RiArrowDropDownLine className="text-2xl" />
//               </button>

//               {constructionOpen && (
//                 <div className="absolute left-0 z-50 w-full mt-2 bg-white border rounded-md shadow-lg">
//                   {["Ready To Move", "New Launch", "Under Construction"].map(
//                     (option) => (
//                       <label
//                         key={option}
//                         className="flex items-center gap-3 px-3 py-2 cursor-pointer hover:bg-gray-100"
//                       >
//                         <input
//                           type="checkbox"
//                           checked={constructionStatus.includes(option)}
//                           onChange={() => toggleConstructionStatus(option)}
//                         />
//                         <span>{option}</span>
//                       </label>
//                     ),
//                   )}

//                   <div className="sticky bottom-0 flex gap-2 p-2 bg-white border-t">
//                     <button
//                       onClick={() => setConstructionStatus([])}
//                       className="w-1/2 py-2 border rounded-md"
//                     >
//                       Clear
//                     </button>

//                     <button
//                       onClick={() => setConstructionOpen(false)}
//                       className="w-1/2 py-2 text-white bg-rose-500 rounded-md"
//                     >
//                       Done
//                     </button>
//                   </div>
//                 </div>
//               )}
//             </div>

//             <div className="relative w-full sm:w-[260px]">
//               <button
//                 type="button"
//                 onClick={() => setAmenitiesOpen(!amenitiesOpen)}
//                 className="flex items-center justify-between w-full h-16 px-4 bg-white border-2 border-gray-300 rounded-md"
//               >
//                 <span className="truncate text-left">
//                   {selectedAmenities.length > 0
//                     ? amenitiesList
//                         .filter((item) =>
//                           selectedAmenities.includes(String(item._id)),
//                         )
//                         .map((item) => item.amenity_name)
//                         .join(", ")
//                     : "Amenities"}
//                 </span>

//                 <RiArrowDropDownLine className="text-2xl" />
//               </button>

//               {amenitiesOpen && (
//                 <div className="absolute left-0 z-50 w-full mt-2 bg-white border rounded-md shadow-lg max-h-72 overflow-y-auto">
//                   {amenitiesList.map((item) => (
//                     <label
//                       key={item._id}
//                       className="flex items-center gap-3 px-3 py-2 cursor-pointer hover:bg-gray-100"
//                     >
//                       <input
//                         type="checkbox"
//                         checked={selectedAmenities.includes(String(item._id))}
//                         onChange={() => toggleAmenity(item._id)}
//                       />

//                       <span>{item.amenity_name}</span>
//                     </label>
//                   ))}

//                   <div className="sticky bottom-0 flex gap-2 p-2 bg-white border-t">
//                     <button
//                       onClick={() => setSelectedAmenities([])}
//                       className="w-1/2 py-2 border rounded-md"
//                     >
//                       Clear
//                     </button>

//                     <button
//                       onClick={() => setAmenitiesOpen(false)}
//                       className="w-1/2 py-2 text-white bg-rose-500 rounded-md"
//                     >
//                       Done
//                     </button>
//                   </div>
//                 </div>
//               )}
//             </div>

//             <div className="w-full sm:w-[180px]">
//               <div className="flex items-center h-16 overflow-hidden bg-white border-2 border-gray-300 rounded-md">
//                 <button
//                   type="button"
//                   onClick={decrementBathrooms}
//                   className="flex items-center justify-center w-14 h-full text-2xl font-bold border-r hover:bg-gray-200"
//                 >
//                   -
//                 </button>

//                 <input
//                   type="number"
//                   min="0"
//                   max="20"
//                   value={bathrooms}
//                   onChange={handleBathroomInput}
//                   placeholder="Bathrooms"
//                   className="w-full h-full text-center focus:outline-none"
//                 />

//                 <button
//                   type="button"
//                   onClick={incrementBathrooms}
//                   className="flex items-center justify-center w-14 h-full text-2xl font-bold border-l hover:bg-gray-200"
//                 >
//                   +
//                 </button>
//               </div>
//             </div>

//             {shouldShowFacingFilter() && (
//               <div className="w-full sm:w-[200px]">
//                 <select
//                   value={facing}
//                   onChange={(e) => setFacing(e.target.value)}
//                   className="w-full h-16 p-2 border-2 border-gray-300 rounded-md focus:outline-none hover:bg-gray-300"
//                 >
//                   <option value="">Facing</option>
//                   <option value="North">North</option>
//                   <option value="East">East</option>
//                   <option value="North-East">North-East</option>
//                   <option value="South-East">South-East</option>
//                   <option value="North-West">North-West</option>
//                   <option value="West">West</option>
//                   <option value="South">South</option>
//                   <option value="South-West">South-West</option>
//                 </select>
//               </div>
//             )}

//             <div className="w-full sm:w-[180px]">
//               <select
//                 value={withPhoto}
//                 onChange={(e) => setWithPhoto(e.target.value)}
//                 className="w-full h-16 p-2 border-2 border-gray-300 rounded-md focus:outline-none hover:bg-gray-300"
//               >
//                 <option value="">With Photo</option>
//                 <option value="Yes">Yes</option>
//                 <option value="No">No</option>
//               </select>
//             </div>

//             <div className="w-full sm:w-[180px]">
//               <select
//                 value={withVideos}
//                 onChange={(e) => setWithVideos(e.target.value)}
//                 className="w-full h-16 p-2 border-2 border-gray-300 rounded-md focus:outline-none hover:bg-gray-300"
//               >
//                 <option value="">With Video</option>
//                 <option value="Yes">Yes</option>
//                 <option value="No">No</option>
//               </select>
//             </div>

//             {/* Sq. Ft Range Dropdown */}
//             <div className="relative w-full sm:w-[240px]">
//               <button
//                 onClick={toggleSquareFtDropdown}
//                 className="flex items-center justify-between w-full h-16 p-2 bg-white border-2 border-gray-300 rounded-md focus:outline-none hover:bg-gray-300"
//               >
//                 <span>
//                   {minSquareFt || maxSquareFt
//                     ? `${minSquareFt || 0} - ${maxSquareFt || "Any"} ${areaIn}`
//                     : "Area"}
//                 </span>

//                 <RiArrowDropDownLine className="text-2xl" />
//               </button>

//               {squareFtDropdownOpen && (
//                 <div className="absolute left-0 mt-2 w-full p-4 bg-white border-2 border-gray-300 rounded-md shadow-lg z-[20]">
//                   {/* Area Unit */}
//                   <label className="text-sm text-gray-600">Area Unit</label>
//                   <select
//                     value={areaIn}
//                     onChange={(e) => setAreaIn(e.target.value)}
//                     className="w-full p-2 mb-3 border-2 border-gray-300 rounded-md focus:outline-none"
//                   >
//                     {areaUnits.map((unit) => (
//                       <option key={unit} value={unit}>
//                         {unit}
//                       </option>
//                     ))}
//                   </select>

//                   {/* Min Area */}
//                   <label className="text-sm text-gray-600">Min Area</label>
//                   <input
//                     type="number"
//                     value={minSquareFt}
//                     onChange={(e) => setMinSquareFt(e.target.value)}
//                     className="w-full p-2 mb-3 border-2 border-gray-300 rounded-md focus:outline-none"
//                     placeholder="Min"
//                   />

//                   {/* Max Area */}
//                   <label className="text-sm text-gray-600">Max Area</label>
//                   <input
//                     type="number"
//                     value={maxSquareFt}
//                     onChange={(e) => setMaxSquareFt(e.target.value)}
//                     className="w-full p-2 border-2 border-gray-300 rounded-md focus:outline-none"
//                     placeholder="Max"
//                   />
//                 </div>
//               )}
//             </div>

//             {propertyType === "PG/Co-living" && (
//               <div className="relative w-full sm:w-[260px]">
//                 <button
//                   type="button"
//                   onClick={() => setSharingTypeOpen(!sharingTypeOpen)}
//                   className="flex items-center justify-between w-full h-16 px-4 bg-white border-2 border-gray-300 rounded-md"
//                 >
//                   <span className="truncate text-left">
//                     {sharingType.length > 0
//                       ? sharingType.join(", ")
//                       : "Sharing Type"}
//                   </span>

//                   <RiArrowDropDownLine className="text-2xl" />
//                 </button>

//                 {sharingTypeOpen && (
//                   <div className="absolute left-0 z-50 w-full mt-2 bg-white border rounded-md shadow-lg">
//                     {[
//                       "Private Rooms",
//                       "2 Per Room",
//                       "More than 2 per room",
//                     ].map((option) => (
//                       <label
//                         key={option}
//                         className="flex items-center gap-3 px-3 py-2 cursor-pointer hover:bg-gray-100"
//                       >
//                         <input
//                           type="checkbox"
//                           checked={sharingType.includes(option)}
//                           onChange={() => toggleSharingType(option)}
//                         />
//                         <span>{option}</span>
//                       </label>
//                     ))}

//                     <div className="sticky bottom-0 flex gap-2 p-2 bg-white border-t">
//                       <button
//                         onClick={() => setSharingType([])}
//                         className="w-1/2 py-2 border rounded-md"
//                       >
//                         Clear
//                       </button>

//                       <button
//                         onClick={() => setSharingTypeOpen(false)}
//                         className="w-1/2 py-2 text-white bg-rose-500 rounded-md"
//                       >
//                         Done
//                       </button>
//                     </div>
//                   </div>
//                 )}
//               </div>
//             )}

//             {propertyType === "Rent" && (
//               <div className="relative w-full sm:w-[260px]">
//                 <button
//                   type="button"
//                   onClick={() => setAvailableFromOpen(!availableFromOpen)}
//                   className="flex items-center justify-between w-full h-16 px-4 bg-white border-2 border-gray-300 rounded-md"
//                 >
//                   <span className="truncate text-left">
//                     {availableFrom.length > 0
//                       ? availableFrom.join(", ")
//                       : "Available From"}
//                   </span>

//                   <RiArrowDropDownLine className="text-2xl" />
//                 </button>

//                 {availableFromOpen && (
//                   <div className="absolute left-0 z-50 w-full mt-2 bg-white border rounded-md shadow-lg">
//                     {[
//                       "Immediately",
//                       "Any Time",
//                       "Within 1 Month",
//                       "After 1 Month",
//                       "Within 3 Month",
//                       "After 3 Month",
//                     ].map((option) => (
//                       <label
//                         key={option}
//                         className="flex items-center gap-3 px-3 py-2 cursor-pointer hover:bg-gray-100"
//                       >
//                         <input
//                           type="checkbox"
//                           checked={availableFrom.includes(option)}
//                           onChange={() => toggleAvailableFrom(option)}
//                         />
//                         <span>{option}</span>
//                       </label>
//                     ))}

//                     <div className="sticky bottom-0 flex gap-2 p-2 bg-white border-t">
//                       <button
//                         onClick={() => setAvailableFrom([])}
//                         className="w-1/2 py-2 border rounded-md"
//                       >
//                         Clear
//                       </button>

//                       <button
//                         onClick={() => setAvailableFromOpen(false)}
//                         className="w-1/2 py-2 text-white bg-rose-500 rounded-md"
//                       >
//                         Done
//                       </button>
//                     </div>
//                   </div>
//                 )}
//               </div>
//             )}

//             {(propertyType === "Rent" || propertyType === "PG/Co-living") && (
//               <div className="relative w-full sm:w-[260px]">
//                 <button
//                   type="button"
//                   onClick={() => setAvailableForOpen(!availableForOpen)}
//                   className="flex items-center justify-between w-full h-16 px-4 bg-white border-2 border-gray-300 rounded-md"
//                 >
//                   <span className="truncate text-left">
//                     {availableFor.length > 0
//                       ? availableFor.join(", ")
//                       : "Available For"}
//                   </span>

//                   <RiArrowDropDownLine className="text-2xl" />
//                 </button>

//                 {availableForOpen && (
//                   <div className="absolute left-0 z-50 w-full mt-2 bg-white border rounded-md shadow-lg max-h-72 overflow-y-auto">
//                     {getAvailableForOptions().map((option) => (
//                       <label
//                         key={option}
//                         className="flex items-center gap-3 px-3 py-2 cursor-pointer hover:bg-gray-100"
//                       >
//                         <input
//                           type="checkbox"
//                           checked={availableFor.includes(option)}
//                           onChange={() => toggleAvailableFor(option)}
//                         />
//                         <span>{option}</span>
//                       </label>
//                     ))}

//                     <div className="sticky bottom-0 flex gap-2 p-2 bg-white border-t">
//                       <button
//                         onClick={() => setAvailableFor([])}
//                         className="w-1/2 py-2 border rounded-md"
//                       >
//                         Clear
//                       </button>

//                       <button
//                         onClick={() => setAvailableForOpen(false)}
//                         className="w-1/2 py-2 text-white bg-rose-500 rounded-md"
//                       >
//                         Done
//                       </button>
//                     </div>
//                   </div>
//                 )}
//               </div>
//             )}

//             {propertyType === "PG/Co-living" && (
//               <div className="relative w-full sm:w-[260px]">
//                 <button
//                   type="button"
//                   onClick={() => setCapacityOpen(!capacityOpen)}
//                   className="flex items-center justify-between w-full h-16 px-4 bg-white border-2 border-gray-300 rounded-md"
//                 >
//                   <span className="truncate text-left">
//                     {capacity.length > 0
//                       ? capacity.join(", ")
//                       : "Total Capacity"}
//                   </span>

//                   <RiArrowDropDownLine className="text-2xl" />
//                 </button>

//                 {capacityOpen && (
//                   <div className="absolute left-0 z-50 w-full mt-2 bg-white border rounded-md shadow-lg">
//                     {["1-2 guest", "2-4 guest", "4-10 guest", "10+ guest"].map(
//                       (option) => (
//                         <label
//                           key={option}
//                           className="flex items-center gap-3 px-3 py-2 cursor-pointer hover:bg-gray-100"
//                         >
//                           <input
//                             type="checkbox"
//                             checked={capacity.includes(option)}
//                             onChange={() => toggleCapacity(option)}
//                           />
//                           <span>{option}</span>
//                         </label>
//                       ),
//                     )}

//                     <div className="sticky bottom-0 flex gap-2 p-2 bg-white border-t">
//                       <button
//                         onClick={() => setCapacity([])}
//                         className="w-1/2 py-2 border rounded-md"
//                       >
//                         Clear
//                       </button>

//                       <button
//                         onClick={() => setCapacityOpen(false)}
//                         className="w-1/2 py-2 text-white bg-rose-500 rounded-md"
//                       >
//                         Done
//                       </button>
//                     </div>
//                   </div>
//                 )}
//               </div>
//             )}

//             {propertyType === "Commercial Buy" && (
//               <div className="relative w-full sm:w-[260px]">
//                 <button
//                   type="button"
//                   onClick={() => setInvestmentOpen(!investmentOpen)}
//                   className="flex items-center justify-between w-full h-16 px-4 bg-white border-2 border-gray-300 rounded-md"
//                 >
//                   <span className="truncate text-left">
//                     {investmentOptions.length > 0
//                       ? investmentOptions.join(", ")
//                       : "Investment Options"}
//                   </span>
//                   <RiArrowDropDownLine className="text-2xl" />
//                 </button>

//                 {investmentOpen && (
//                   <div className="absolute left-0 z-50 w-full mt-2 bg-white border rounded-md shadow-lg">
//                     {investmentOptionsList.map((option) => (
//                       <label
//                         key={option}
//                         className="flex items-center gap-3 px-3 py-2 cursor-pointer hover:bg-gray-100"
//                       >
//                         <input
//                           type="checkbox"
//                           checked={investmentOptions.includes(option)}
//                           onChange={() => toggleInvestmentOption(option)}
//                         />
//                         <span>{option}</span>
//                       </label>
//                     ))}

//                     <div className="sticky bottom-0 flex gap-2 p-2 bg-white border-t">
//                       <button
//                         onClick={() => setInvestmentOptions([])}
//                         className="w-1/2 py-2 border rounded-md"
//                       >
//                         Clear
//                       </button>

//                       <button
//                         onClick={() => setInvestmentOpen(false)}
//                         className="w-1/2 py-2 text-white bg-rose-500 rounded-md"
//                       >
//                         Done
//                       </button>
//                     </div>
//                   </div>
//                 )}
//               </div>
//             )}

//             {propertyType === "Commercial Buy" && (
//               <div className="w-full sm:w-[200px]">
//                 <select
//                   value={purchaseType}
//                   onChange={(e) => setPurchaseType(e.target.value)}
//                   className="w-full h-16 p-2 border-2 border-gray-300 rounded-md focus:outline-none hover:bg-gray-300"
//                 >
//                   <option value="">Purchase Type</option>
//                   {purchaseTypeOptions.map((option) => (
//                     <option key={option} value={option}>
//                       {option}
//                     </option>
//                   ))}
//                 </select>
//               </div>
//             )}

//             {(propertyType === "Commercial Buy" ||
//               propertyType === "Commercial Lease") &&
//               buildingType === "Commercial" &&
//               propertyType2.includes("Plot/Land") && (
//                 <div className="relative w-full sm:w-[260px]">
//                   <button
//                     type="button"
//                     onClick={() => setPlotLandOpen(!plotLandOpen)}
//                     className="flex items-center justify-between w-full h-16 px-4 bg-white border-2 border-gray-300 rounded-md"
//                   >
//                     <span className="truncate text-left">
//                       {plotLandTypes.length > 0
//                         ? plotLandTypes.join(", ")
//                         : "Plot/Land Type"}
//                     </span>
//                     <RiArrowDropDownLine className="text-2xl" />
//                   </button>

//                   {plotLandOpen && (
//                     <div className="absolute left-0 z-50 w-full mt-2 bg-white border rounded-md shadow-lg">
//                       {plotLandOptions.map((option) => (
//                         <label
//                           key={option}
//                           className="flex items-center gap-3 px-3 py-2 cursor-pointer hover:bg-gray-100"
//                         >
//                           <input
//                             type="checkbox"
//                             checked={plotLandTypes.includes(option)}
//                             onChange={() => togglePlotLandType(option)}
//                           />
//                           <span>{option}</span>
//                         </label>
//                       ))}

//                       <div className="sticky bottom-0 flex gap-2 p-2 bg-white border-t">
//                         <button
//                           onClick={() => setPlotLandTypes([])}
//                           className="w-1/2 py-2 border rounded-md"
//                         >
//                           Clear
//                         </button>

//                         <button
//                           onClick={() => setPlotLandOpen(false)}
//                           className="w-1/2 py-2 text-white bg-rose-500 rounded-md"
//                         >
//                           Done
//                         </button>
//                       </div>
//                     </div>
//                   )}
//                 </div>
//               )}

//             {propertyType === "Commercial Lease" &&
//               buildingType === "Commercial" &&
//               propertyType2.includes("Office Space") && (
//                 <div className="relative w-full sm:w-[260px]">
//                   <button
//                     type="button"
//                     onClick={() => setOfficeTypeOpen(!officeTypeOpen)}
//                     className="flex items-center justify-between w-full h-16 px-4 bg-white border-2 border-gray-300 rounded-md"
//                   >
//                     <span className="truncate text-left">
//                       {officeType.length > 0
//                         ? officeType.join(", ")
//                         : "Office Type"}
//                     </span>
//                     <RiArrowDropDownLine className="text-2xl" />
//                   </button>

//                   {officeTypeOpen && (
//                     <div className="absolute left-0 z-50 w-full mt-2 bg-white border rounded-md shadow-lg">
//                       {officeTypeOptions.map((option) => (
//                         <label
//                           key={option}
//                           className="flex items-center gap-3 px-3 py-2"
//                         >
//                           <input
//                             type="checkbox"
//                             checked={officeType.includes(option)}
//                             onChange={() =>
//                               setOfficeType((prev) =>
//                                 prev.includes(option)
//                                   ? prev.filter((i) => i !== option)
//                                   : [...prev, option],
//                               )
//                             }
//                           />
//                           <span>{option}</span>
//                         </label>
//                       ))}
//                     </div>
//                   )}
//                 </div>
//               )}

//             {propertyType === "Commercial Lease" &&
//               buildingType === "Commercial" &&
//               propertyType2.includes("Retail Shops/Showrooms") && (
//                 <div className="relative w-full sm:w-[260px]">
//                   <button
//                     type="button"
//                     onClick={() => setRetailTypeOpen(!retailTypeOpen)}
//                     className="flex items-center justify-between w-full h-16 px-4 bg-white border-2 border-gray-300 rounded-md"
//                   >
//                     <span>
//                       {retailType.length > 0
//                         ? retailType.join(", ")
//                         : "Retail Type"}
//                     </span>
//                     <RiArrowDropDownLine className="text-2xl" />
//                   </button>

//                   {retailTypeOpen && (
//                     <div className="absolute left-0 z-50 w-full mt-2 bg-white border rounded-md shadow-lg">
//                       {retailTypeOptions.map((option) => (
//                         <label
//                           key={option}
//                           className="flex items-center gap-3 px-3 py-2"
//                         >
//                           <input
//                             type="checkbox"
//                             checked={retailType.includes(option)}
//                             onChange={() =>
//                               setRetailType((prev) =>
//                                 prev.includes(option)
//                                   ? prev.filter((i) => i !== option)
//                                   : [...prev, option],
//                               )
//                             }
//                           />
//                           <span>{option}</span>
//                         </label>
//                       ))}
//                     </div>
//                   )}
//                 </div>
//               )}

//             {propertyType === "Commercial Lease" &&
//               buildingType === "Commercial" &&
//               propertyType2.includes("Other Commercial spaces") && (
//                 <div className="relative w-full sm:w-[260px]">
//                   <button
//                     type="button"
//                     onClick={() => setOtherCommercialOpen(!otherCommercialOpen)}
//                     className="flex items-center justify-between w-full h-16 px-4 bg-white border-2 border-gray-300 rounded-md"
//                   >
//                     <span>
//                       {otherCommercialType.length > 0
//                         ? otherCommercialType.join(", ")
//                         : "Other Commercial Type"}
//                     </span>
//                     <RiArrowDropDownLine className="text-2xl" />
//                   </button>

//                   {otherCommercialOpen && (
//                     <div className="absolute left-0 z-50 w-full mt-2 bg-white border rounded-md shadow-lg">
//                       {otherCommercialOptions.map((option) => (
//                         <label
//                           key={option}
//                           className="flex items-center gap-3 px-3 py-2"
//                         >
//                           <input
//                             type="checkbox"
//                             checked={otherCommercialType.includes(option)}
//                             onChange={() =>
//                               setOtherCommercialType((prev) =>
//                                 prev.includes(option)
//                                   ? prev.filter((i) => i !== option)
//                                   : [...prev, option],
//                               )
//                             }
//                           />
//                           <span>{option}</span>
//                         </label>
//                       ))}
//                     </div>
//                   )}
//                 </div>
//               )}
//             {/* Action Buttons */}
//             <div className="flex flex-wrap gap-4 ">
//               <button
//                 onClick={handleButtonClick}
//                 className="w-40 p-3 text-rose-700 my-border rounded-md hover:bg-gray-300 focus:outline-none"
//               >
//                 {filtersApplied ? "Reset Filters" : "Apply Filter"}
//               </button>
//               <button
//                 className="w-40 p-3 my-border rounded-md hover:bg-gray-300 focus:outline-none"
//                 onClick={handleSaveSearch}
//               >
//                 Save Search
//               </button>
//             </div>
//           </div>
//         </div>
//       </div>

//       {/* Main Content */}
//       <div className="flex flex-col p-1 space-y-4 sm:p-6 bg-rose-50 rounded-xl">
//         <div className="flex-grow">
//           <div className="flex flex-col bg-white border-white shadow-md sm:flex-row-reverse">
//             <div
//               className="z-10 flex-1 p-4 border-white no-scrollbar"
//               style={{ scrollbarWidth: "none" }}
//             >
//               {/* --- Advertisement Banner --- */}
//               {/* <div className="w-full mb-3 sm:w-100">
//                       <div className="relative w-full h-48 overflow-hidden shadow-md rounded-2xl">
//                         <img
//                           src="/image/r1.jpg" // Replace with your actual image
//                           alt="Advertisement"
//                           className="object-cover w-full h-full"
//                         />
//                         <div className="absolute inset-0 flex items-center justify-center bg bg-opacity-30">
//                           <h2 className="text-3xl font-bold text-white">Advertisement</h2>
//                         </div>
//                       </div>
//                     </div> */}

//               {/* Right: Properties */}
//               <div className="grid grid-cols-1 gap-6 sm:grid-cols-2 md:grid-cols-2">
//                 {properties.length > 0 ? (
//                   properties.map((property) => (
//                     <div
//                       key={property._id}
//                       className={`shadow-md rounded-2xl overflow-hidden block no-underline hover:no-underline ${
//                         hoveredPropertyId === property._id ? "bg-green-200" : ""
//                       }`}
//                       onMouseEnter={() => setHoveredPropertyId(property._id)}
//                       onMouseLeave={() => setHoveredPropertyId(null)}
//                     >
//                       <div className="relative" key={property._id}>
//                         <Link
//                           to={`/propertydetails/${property._id}`}
//                           className="block overflow-hidden no-underline bg-white border-2 rounded-lg hover:no-underline"
//                         >
//                           {1 + (property?.property_images?.length || 0) > 1 ? (
//                             <Slider
//                               dots
//                               infinite
//                               speed={500}
//                               slidesToShow={1}
//                               slidesToScroll={1}
//                               arrows
//                               autoplay
//                               autoplaySpeed={2000}
//                               beforeChange={(current, next) =>
//                                 setActiveIndexes((prev) => ({
//                                   ...prev,
//                                   [property._id]: next,
//                                 }))
//                               }
//                               initialSlide={activeIndexes[property._id] || 0}
//                               customPaging={(i) => {
//                                 const activeSlide =
//                                   activeIndexes[property._id] || 0;
//                                 const totalImages =
//                                   1 + (property?.property_images?.length || 0);
//                                 const isActive =
//                                   i === activeSlide % totalImages;
//                                 return (
//                                   <div
//                                     style={{
//                                       width: "10px",
//                                       height: "10px",
//                                       borderRadius: "50%",
//                                       background: isActive ? "#fff" : "#888",
//                                       margin: "0 5px",
//                                       cursor: "pointer",
//                                     }}
//                                   />
//                                 );
//                               }}
//                               appendDots={(dots) => {
//                                 const totalImages =
//                                   1 + (property?.property_images?.length || 0);
//                                 const visibleDots = dots.slice(0, totalImages);
//                                 return (
//                                   <div
//                                     style={{
//                                       position: "absolute",
//                                       bottom: "10px",
//                                       left: "50%",
//                                       transform: "translateX(-50%)",
//                                       display: "flex",
//                                       justifyContent: "center",
//                                       width: "100%",
//                                     }}
//                                   >
//                                     {visibleDots}
//                                   </div>
//                                 );
//                               }}
//                               className="rounded-t-2xl"
//                             >
//                               {/* First slide: cover image */}
//                               <div key={`cover-${property._id}`}>
//                                 <img
//                                   src={property.cover_image}
//                                   alt="Cover"
//                                   className="object-cover w-full h-48 rounded-t-2xl"
//                                 />
//                               </div>

//                               {/* Other property images */}
//                               {(property?.property_images || []).map(
//                                 (imgObj) => (
//                                   <div key={imgObj._id}>
//                                     <img
//                                       src={imgObj.image}
//                                       alt="Property"
//                                       className="object-cover w-full h-48 rounded-t-2xl"
//                                     />
//                                   </div>
//                                 ),
//                               )}
//                             </Slider>
//                           ) : (
//                             // Just one image — no slider
//                             <div>
//                               <img
//                                 src={property.cover_image}
//                                 alt="Cover"
//                                 className="object-cover w-full h-48 rounded-t-2xl"
//                               />
//                             </div>
//                           )}
//                         </Link>

//                         {/* 10 Days ZeroBriks Tag (Top Left) */}
//                         <span className="absolute px-2 py-1 text-xs font-normal text-white rounded-full top-2 left-2 bg-gray-800/60 backdrop-blur-sm">
//                           {property.days_since_created} days on ZeroBriks
//                         </span>

//                         {/* Virtual Tour & Heart Icon (Top Right) */}
//                         <div className="absolute flex items-center space-x-2 top-2 right-2">
//                           {property.virtual_tour_availability === "Yes" && (
//                             <span className="flex items-center gap-1 px-2 py-1 text-xs font-normal text-white rounded-full bg-gray-800/60 backdrop-blur-sm">
//                               <PiCubeFocus className="text-sm text-white" />
//                               Virtual Tour
//                             </span>
//                           )}
//                           <button
//                             className="bg-gray-800/60 backdrop-blur-sm p-1.5 rounded-full shadow"
//                             onClick={(e) => {
//                               if (!accessToken) {
//                                 setIsLoginModalOpen(true);
//                                 return;
//                               }
//                               e.preventDefault();
//                               if (property.is_favorite) {
//                                 removeFromFavorites(property.favorite_id);
//                               } else {
//                                 addToFavorites(property._id);
//                               }
//                             }}
//                           >
//                             <Heart
//                               size={20}
//                               stroke={property.is_favorite ? "none" : "white"}
//                               color={
//                                 property.is_favorite
//                                   ? "red"
//                                   : "rgba(75, 85, 99, 0.4) "
//                               }
//                               fill={
//                                 property.is_favorite
//                                   ? "red"
//                                   : "rgba(75, 85, 99, 0.4) "
//                               }
//                               strokeWidth={2}
//                             />
//                           </button>
//                         </div>

//                         {/* FOR BUY / RENT / UNKNOWN Tag (Bottom Left) */}
//                         <div className="absolute bottom-0 left-0">
//                           {(() => {
//                             const rawCategory =
//                               property.property_category_type || "";

//                             const normalizedCategory = rawCategory
//                               .replace(/\s+/g, " ")
//                               .replace(/-/g, " ")
//                               .replace(/\//g, " ")
//                               .trim()
//                               .toLowerCase();

//                             let badgeText = "UNKNOWN";
//                             let badgeColor = "bg-gray-500";

//                             if (normalizedCategory === "buy") {
//                               badgeText = "FOR BUY";
//                               badgeColor = "bg-green-500";
//                             } else if (normalizedCategory === "rent") {
//                               badgeText = "FOR RENT";
//                               badgeColor = "bg-blue-500";
//                             } else if (
//                               normalizedCategory.includes("commercial buy")
//                             ) {
//                               badgeText = "COMMERCIAL BUY";
//                               badgeColor = "bg-purple-500";
//                             } else if (
//                               normalizedCategory.includes("commercial lease")
//                             ) {
//                               badgeText = "COMMERCIAL LEASE";
//                               badgeColor = "bg-indigo-500";
//                             } else if (
//                               normalizedCategory.includes("pg") ||
//                               normalizedCategory.includes("co living") ||
//                               normalizedCategory.includes("coliving")
//                             ) {
//                               badgeText = "PG / CO-LIVING";
//                               badgeColor = "bg-yellow-500";
//                             } else if (
//                               normalizedCategory.includes("residential")
//                             ) {
//                               badgeText = "RESIDENTIAL";
//                               badgeColor = "bg-pink-500";
//                             }

//                             return (
//                               <span
//                                 className={`text-white text-xs px-3 py-1 rounded-se-lg ${badgeColor}`}
//                               >
//                                 {badgeText}
//                               </span>
//                             );
//                           })()}
//                         </div>

//                         {/* FEATURED Tag (Bottom Right) */}
//                         <div className="absolute bottom-0 right-0">
//                           {property.mark_as_featured === "Yes" && (
//                             <div className="absolute bottom-0 right-0">
//                               <span className="px-3 py-1 text-xs text-white bg-yellow-500 rounded-ss-lg">
//                                 FEATURED
//                               </span>
//                             </div>
//                           )}
//                         </div>
//                       </div>

//                       {/* Property Description */}
//                       <div className="p-1">
//                         <div className="flex items-center justify-between">
//                           <h3 className="text-xl font-semibold text-gray-800 truncate">
//                             {property.property_name}
//                           </h3>
//                           <FontAwesomeIcon
//                             icon={faShareNodes}
//                             className="p-2 text-gray-500 bg-white rounded shadow cursor-pointer"
//                             onClick={() =>
//                               openShareModal1(
//                                 `${window.location.origin}/property/${property._id}`,
//                                 property._id,
//                               )
//                             }
//                           />
//                         </div>

//                         {/* Property Details */}
//                         <div className="flex flex-wrap items-center gap-4 mt-1 text-gray-700">
//                           {/* Price */}
//                           <div className="flex items-center gap-1 text-lg font-semibold">
//                             <FaRupeeSign className="text-xl my-text" />
//                             {property.property_category_type === "Rent" ? (
//                               <span>
//                                 {Number(property.rent) >= 10000000
//                                   ? (Number(property.rent) / 10000000)
//                                       .toFixed(1)
//                                       .replace(/\.0$/, "") + " Cr"
//                                   : Number(property.rent) >= 100000
//                                     ? (Number(property.rent) / 100000)
//                                         .toFixed(1)
//                                         .replace(/\.0$/, "") + " L"
//                                     : Number(property.rent) >= 1000
//                                       ? (Number(property.rent) / 1000)
//                                           .toFixed(1)
//                                           .replace(/\.0$/, "") + " K"
//                                       : property.rent || "N/A"}
//                                 {property.rent_duration &&
//                                 property.rent_duration !== "N/A"
//                                   ? ` / ${property.rent_duration}`
//                                   : ""}
//                               </span>
//                             ) : (
//                               <span>
//                                 {Number(property.property_price) >= 10000000
//                                   ? (Number(property.property_price) / 10000000)
//                                       .toFixed(1)
//                                       .replace(/\.0$/, "") + " Cr"
//                                   : Number(property.property_price) >= 100000
//                                     ? (Number(property.property_price) / 100000)
//                                         .toFixed(1)
//                                         .replace(/\.0$/, "") + " L"
//                                     : Number(property.property_price) >= 1000
//                                       ? (Number(property.property_price) / 1000)
//                                           .toFixed(1)
//                                           .replace(/\.0$/, "") + " K"
//                                       : property.property_price || "N/A"}
//                               </span>
//                             )}
//                           </div>

//                           {/* BHK Type */}
//                           {property.bhk_type && (
//                             <div className="flex items-center gap-1">
//                               <MdOutlineBedroomParent className="text-xl my-text" />
//                               <p className="m-0 font-semibold">
//                                 {property.bhk_type}
//                               </p>
//                             </div>
//                           )}

//                           {/* Area */}
//                           {property.area_sq && (
//                             <div className="flex items-center gap-1">
//                               <BiArea className="text-xl my-text" />
//                               <p className="m-0 font-semibold">
//                                 {property.area_sq} sq ft
//                               </p>
//                             </div>
//                           )}
//                         </div>

//                         {/* Furnished */}
//                         {property.furnished_type && (
//                           <div className="flex items-center mt-2">
//                             <FontAwesomeIcon
//                               icon={faChair}
//                               className="mr-1 my-text"
//                             />
//                             <p className="m-0 font-semibold text-black">
//                               {property.furnished_type}
//                             </p>
//                           </div>
//                         )}

//                         {/* Address */}
//                         <p className="flex items-center gap-2 mt-1 text-sm font-bold text-gray-500 truncate">
//                           <img
//                             src="/image/address_icon.png" // replace with your actual icon path
//                             alt="Location Icon"
//                             className="object-contain w-4 h-4"
//                           />
//                           {property.address_area || "No Address Provided"}
//                         </p>

//                         {/* Owner Info */}
//                         <div className="flex items-center justify-between mb-0 p-2">
//                           {/* LEFT SIDE - Owner */}
//                           <div className="flex flex-col items-center">
//                             <div className="p-2 rounded-full bg-slate-100">
//                               {property.property_owner_image ? (
//                                 <img
//                                   src={`${process.env.REACT_APP_API_URL}/media/${property.property_owner_image}`}
//                                   alt="Owner"
//                                   className="object-cover w-10 h-10 rounded-full"
//                                 />
//                               ) : (
//                                 <AiOutlineUser
//                                   className="text-gray-600"
//                                   size={30}
//                                 />
//                               )}
//                             </div>

//                             <span className="text-sm font-semibold mt-1">
//                               {property.connect_to_name}
//                             </span>

//                             <span className="text-xs text-gray-500">
//                               {property.user_type}
//                             </span>
//                           </div>

//                           {/* RIGHT SIDE - Buttons */}
//                           <div className="flex items-center gap-2">
//                             {/* Contact */}
//                             <div
//                               className="flex items-center justify-center w-24 h-9 text-sm text-white rounded-lg cursor-pointer my-bg"
//                               onClick={() => handleContactClick(property)}
//                             >
//                               Contact
//                             </div>

//                             {/* WhatsApp */}
//                             <a
//                               href={`https://wa.me/91${property.connect_to_no}?text=Hello, I am interested in your property`}
//                               target="_blank"
//                               rel="noopener noreferrer"
//                               onClick={(e) => e.stopPropagation()}
//                               className="flex items-center justify-center w-9 h-9 text-white bg-green-500 rounded-lg hover:bg-green-600"
//                             >
//                               <FaWhatsapp />
//                             </a>

//                             {/* Call */}
//                             <a
//                               href={`tel:${property.connect_to_no}`}
//                               onClick={(e) => e.stopPropagation()}
//                               className="flex items-center justify-center w-9 h-9 text-white bg-blue-500 rounded-lg hover:bg-blue-600"
//                             >
//                               <FaPhone />
//                             </a>
//                           </div>
//                         </div>
//                       </div>
//                     </div>
//                   ))
//                 ) : (
//                   <div className="text-center text-black">
//                     <p>No properties available at the moment.</p>
//                   </div>
//                 )}
//               </div>
//               {isContactModalOpen && selectedProperty && (
//                 <ContactDetails
//                   fullName={
//                     freeViewCount <= 0 && paidViewCount <= 0
//                       ? `****${selectedProperty.connect_to_name?.slice(-1) || "N/A"}`
//                       : selectedProperty.connect_to_name || "N/A"
//                   }
//                   mobile={
//                     freeViewCount <= 0 && paidViewCount <= 0
//                       ? `*******${selectedProperty.connect_to_no?.slice(-3) || "000"}`
//                       : selectedProperty.connect_to_no || "N/A"
//                   }
//                   showUpgradePrompt={showUpgradePrompt}
//                   onClose={() => setIsContactModalOpen(false)}
//                 />
//               )}

//               {/* Pagination */}
//               {totalPages > 1 && (
//                 <div className="flex items-center justify-center gap-2 mt-4">
//                   <button
//                     onClick={() =>
//                       setCurrentPage((prev) => Math.max(prev - 1, 1))
//                     }
//                     disabled={currentPage === 1}
//                     className={`w-8 h-8 flex items-center justify-center rounded-full border-2 border-gray-300 
//                        ${currentPage === 1 ? "opacity-50 cursor-not-allowed" : ""}`}
//                   >
//                     <MdOutlineNavigateBefore className="text-xl text-gray-700" />
//                   </button>

//                   {getPaginationRange().map((page, index) => (
//                     <button
//                       key={index}
//                       onClick={() =>
//                         typeof page === "number" && setCurrentPage(page)
//                       }
//                       className={`px-3 py-1 text-sm transition-colors 
//                          ${currentPage === page ? "rounded-full my-border w-8 h-8 flex items-center justify-center font-normal" : "text-gray-700"}
//                        `}
//                     >
//                       {page}
//                     </button>
//                   ))}

//                   <button
//                     onClick={() =>
//                       setCurrentPage((prev) => Math.min(prev + 1, totalPages))
//                     }
//                     disabled={currentPage === totalPages}
//                     className={`w-8 h-8 flex items-center justify-center rounded-full border-2 border-gray-300 
//                        ${currentPage === totalPages ? "opacity-50 cursor-not-allowed" : ""}`}
//                   >
//                     <MdOutlineNavigateNext className="text-xl text-gray-700" />
//                   </button>
//                 </div>
//               )}
//             </div>

//             {/* Left: Map */}
//             <div className="flex sticky top-0 w-full sm:w-3/4 md:w-1/2 lg:w-[560px]] h-screen overflow-hidden bg-white rounded-lg">
//               {loading ? (
//                 <p>Loading properties...</p>
//               ) : (
//                 <MapContainer
//                   center={getMapCenter()}
//                   zoom={12}
//                   scrollWheelZoom={false}
//                   style={{ width: "100%", height: "100%" }}
//                 >
//                   <TileLayer url="https://server.arcgisonline.com/ArcGIS/rest/services/World_Topo_Map/MapServer/tile/{z}/{y}/{x}" />
//                   {properties.map((property, index) => (
//                     <Marker
//                       key={property._id}
//                       position={[property.latitude, property.longitude]}
//                       icon={createCustomIcon(
//                         property,
//                         property._id === activePropertyId ||
//                           property._id === hoveredPropertyId,
//                       )}
//                       eventHandlers={{
//                         mouseover: () => setHoveredPropertyId(property._id),
//                         mouseout: () => setHoveredPropertyId(null),
//                       }}
//                     >
//                       <Popup>
//                         <div className="w-full sm:w-[300px] relative">
//                           {/* Heart Button */}
//                           <button
//                             className="absolute z-10 top-2 right-2"
//                             onClick={(e) => {
//                               e.stopPropagation();
//                               toggleFavorite(property._id);
//                             }}
//                           >
//                             {isFavorited ? (
//                               <FaHeart className="text-red-500" />
//                             ) : (
//                               <FaRegHeart />
//                             )}
//                           </button>

//                           {/* Slider Implementation */}
//                           <div className="relative">
//                             <img
//                               src={
//                                 propertyImages[currentIndex]?.image
//                                   ? `${process.env.REACT_APP_API_URL}${propertyImages[currentIndex]?.image}`
//                                   : `${property.cover_image}`
//                               }
//                               alt={`Property Image ${currentIndex + 1}`}
//                               className="w-full h-[200px] object-cover"
//                             />
//                             <button
//                               onClick={(e) => {
//                                 e.stopPropagation();
//                                 handlePrev();
//                               }}
//                               className="absolute p-1 transform -translate-y-1/2 bg-white rounded top-1/2 left-1 pe-2"
//                             >
//                               <b>&#x3008;</b>
//                             </button>
//                             <button
//                               onClick={(e) => {
//                                 e.stopPropagation();
//                                 handleNext();
//                               }}
//                               className="absolute p-1 transform -translate-y-1/2 bg-white rounded top-1/2 right-1 ps-2"
//                             >
//                               <b>&#x232A;</b>
//                             </button>
//                           </div>

//                           {/* Property Info */}
//                           <div className="px-2">
//                             <div className="flex items-center justify-between text-lg font-semibold text-black">
//                               <div className="flex items-center">
//                                 <BiRupee className="mr-1 text-black bg-white" />
//                                 <span>
//                                   {property.property_category_type === "Rent"
//                                     ? formatPrice(property.rent)
//                                     : formatPrice(property.property_price)}
//                                 </span>
//                               </div>
//                               <Link
//                                 key={property._id}
//                                 to={`/propertydetails/${property._id}`}
//                                 className="block no-underline bg-white border-2 rounded-lg hover:no-underline"
//                               >
//                                 <button className="flex items-center text-white rounded-full btn btn-secondary">
//                                   <b>
//                                     <AiOutlineInfo />
//                                   </b>
//                                 </button>
//                               </Link>
//                             </div>
//                             <div className="text-sm text-gray-600">
//                               <p className="m-0">
//                                 <strong>{property.bhk_type}</strong> |{" "}
//                                 {property.city_name} | {property.area_sq} sq ft
//                               </p>
//                               <p className="m-0">{property.address}</p>
//                             </div>
//                           </div>
//                         </div>
//                       </Popup>
//                     </Marker>
//                   ))}
//                 </MapContainer>
//               )}
//             </div>

//             {isShareModalOpen && (
//               <div className="absolute right-0 z-50">
//                 <ShareModal
//                   currentShareUrl={currentShareUrl}
//                   copyLink={() => {
//                     const url = currentShareUrl;

//                     if (navigator.clipboard && window.isSecureContext) {
//                       navigator.clipboard
//                         .writeText(url)
//                         .then(() => alert("Link copied!"))
//                         .catch((err) => {
//                           console.error(err);
//                           fallbackCopyTextToClipboard(url);
//                         });
//                     } else {
//                       fallbackCopyTextToClipboard(url);
//                     }

//                     function fallbackCopyTextToClipboard(text) {
//                       const textArea = document.createElement("textarea");
//                       textArea.value = text;
//                       textArea.style.position = "fixed"; // Prevent scrolling
//                       textArea.style.left = "-9999px";
//                       document.body.appendChild(textArea);
//                       textArea.focus();
//                       textArea.select();

//                       try {
//                         const successful = document.execCommand("copy");
//                         alert(successful ? "Link copied!" : "Copy failed");
//                       } catch (err) {
//                         console.error("Fallback: Could not copy text: ", err);
//                         alert("Copy failed");
//                       }

//                       document.body.removeChild(textArea);
//                     }
//                   }}
//                 />
//               </div>
//             )}

//             <Login1
//               isOpen={isLoginModalOpen}
//               onClose={() => setIsLoginModalOpen(false)}
//               onSwitchToSignUp={() => {
//                 setIsLoginModalOpen(false);
//                 setIsSignUpModalOpen(true);
//               }}
//             />
//             <SignUp1
//               isOpen={isSignUpModalOpen}
//               onClose={() => setIsSignUpModalOpen(false)}
//               onSwitchToLogin={() => {
//                 setIsSignUpModalOpen(false);
//                 setIsLoginModalOpen(true);
//               }}
//             />
//           </div>
//         </div>
//       </div>
//     </>
//   );
// };
// export default AdvisorDashboard;



import React, { useState, useEffect, useRef } from "react";
import { MapContainer, TileLayer, Marker, Popup, useMap } from "react-leaflet";
import "leaflet/dist/leaflet.css";
import L from "leaflet";
import axios from "axios";
import { useLocation, Link } from "react-router-dom";
import { RiArrowDropDownLine } from "react-icons/ri";
import {
  MdOutlineNavigateBefore,
  MdOutlineNavigateNext,
  MdOutlineBedroomParent,
} from "react-icons/md";
import { BiArea } from "react-icons/bi";
import { AiOutlineUser } from "react-icons/ai";
import {
  FaRupeeSign,
  FaWhatsapp,
  FaPhone,
  FaMapMarkerAlt,
} from "react-icons/fa";
import { PiCubeFocus } from "react-icons/pi";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faShareNodes, faChair } from "@fortawesome/free-solid-svg-icons";
import Slider from "react-slick";
import { Heart } from "lucide-react";
import { toast } from "react-toastify";
import ShareModal from "../containers/ShareModal";
import Login1 from "../auth/Login1";
import SignUp1 from "../auth/SignUp1";
import { useCity } from "./SearchContext";
import ContactDetails from "../containers/ContactDetails";

// ============================================================
// CONSTANTS
// ============================================================

const DEFAULT_CENTER = [18.5204, 73.8567];
const ITEMS_PER_PAGE = 10;
const TILE_URL =
  "https://server.arcgisonline.com/ArcGIS/rest/services/World_Topo_Map/MapServer/tile/{z}/{y}/{x}";

const selectCls =
  "h-8 px-2 text-xs border border-gray-300 rounded-lg bg-white hover:border-[#8B1E3F] focus:outline-none focus:ring-1 focus:ring-[#8B1E3F] transition-colors";
const btnCls =
  "flex items-center justify-between w-full h-8 px-2 text-xs bg-white border border-gray-300 rounded-lg hover:border-[#8B1E3F] transition-colors";
const panelCls =
  "absolute left-0 right-0 z-[999] mt-1 bg-white border border-gray-200 rounded-lg shadow-xl";

const PRICE_OPTIONS = [
  ...Array.from({ length: 19 }, (_, i) => (i + 1) * 500000),
  10000000, 12500000, 15000000, 17500000, 20000000, 25000000, 30000000,
  40000000, 50000000, 75000000, 100000000, 150000000, 200000000, 250000000,
  300000000, 400000000, 500000000, 600000000, 700000000, 750000000, 900000000,
  1000000000, 1500000000, 2000000000, 2500000000, 3000000000, 4000000000,
  5000000000, 6000000000, 7000000000, 7500000000, 9000000000, 10000000000,
];

const AREA_UNITS = [
  "sq.ft", "sq.yards", "sq.m", "acre", "marla", "cents", "bigha", "kottah",
  "kanal", "grounds", "ares", "biswa", "guntha", "aankadam", "hectares",
  "rood", "chataks", "perch",
];

const BHK_OPTIONS = [
  "Studio", "1 RK", "1 BHK", "1.5 BHK", "2 BHK", "2.5 BHK", "3 BHK",
  "3.5 BHK", "4 BHK", "5 BHK", "6+ BHK",
];

const FACING_OPTIONS = [
  "North", "East", "North-East", "South-East", "North-West", "West", "South", "South-West",
];

const OFFICE_OPTIONS = [
  "Ready to move office space",
  "Bare shell office space",
  "Co-working office space",
];
const RETAIL_OPTIONS = [
  "Mall", "Commercial Project", "Residential Project",
  "Retail Complex/Building", "Market/High Street",
];
const OTHER_COMMERCIAL_OPTIONS = [
  "Factory", "Ware House", "Hotel Resorts", "Guest-House/Banquet-Halls",
  "Cold Storage", "Manufacturing", "Others",
];
const COMMERCIAL_BUY_TYPES = [
  "Ready to move office space", "Bare shell office space", "Ware House",
  "Factory", "Hotel/Resorts", "Others", "Plot/Land", "Cold Storage",
  "Manufacturing", "Guest-House/Banquet-Halls", "Retail",
];
const PLOT_LAND_OPTIONS = [
  "Commercial Land/Inst. Land", "Industrial Lands/Plots", "Agricultural/Farm Land",
];
const INVESTMENT_OPTIONS = [
  "Pre-leased Spaces", "Restaurants", "SCO Plots", "Business Center",
  "Food Court", "Multiplex", "Co-working",
];
const PURCHASE_TYPE_OPTIONS = ["Resale", "New bookings"];
const CAPACITY_OPTIONS = ["1-2 guest", "2-4 guest", "4-10 guest", "10+ guest"];
const CAPACITY_MAP = {
  "1-2 guest": "1-2",
  "2-4 guest": "2-4",
  "4-10 guest": "4-10",
  "10+ guest": "10+",
};

const initialFilters = {
  propertyType: "",
  buildingType: "",
  propertyTypes: [],
  plotLandTypes: [],
  officeType: [],
  retailType: [],
  otherCommercialType: [],
  minPrice: "",
  maxPrice: "",
  bhkType: "",
  furnishedStatus: "",
  postedBy: "",
  constructionStatus: [],
  amenities: [],
  bathrooms: "",
  facing: "",
  withPhoto: "",
  withVideos: "",
  minArea: "",
  maxArea: "",
  areaIn: "sq.ft",
  sharingType: [],
  availableFrom: [],
  availableFor: [],
  capacity: [],
  investmentOptions: [],
  purchaseType: "",
};

// ============================================================
// HELPERS
// ============================================================

const asOptions = (arr) => arr.map((v) => ({ value: v, label: v }));

const parseCities = (str) => {
  if (!str) return [];
  return str
    .split(",")
    .map((c) => c.trim())
    .filter(Boolean);
};

const formatPriceMinMax = (value) => {
  const num = Number(value);
  if (num >= 10000000) return (num / 10000000).toFixed(1).replace(/\.0$/, "") + " Cr";
  if (num >= 100000) return (num / 100000).toFixed(1).replace(/\.0$/, "") + " L";
  if (num >= 1000) return (num / 1000).toFixed(1).replace(/\.0$/, "") + " K";
  return num;
};

const formatPrice = (price) => {
  const n = Number(price);
  if (!price || isNaN(n) || n <= 0) return "On request";
  if (n >= 10000000) return `₹ ${(n / 10000000).toFixed(2)} Cr`;
  if (n >= 100000) return `₹ ${(n / 100000).toFixed(2)} L`;
  if (n >= 1000) return `₹ ${(n / 1000).toFixed(2)} K`;
  return `₹ ${n}`;
};

const formatAmount = (value) => {
  const n = Number(value);
  if (!n) return value || "N/A";
  if (n >= 10000000) return (n / 10000000).toFixed(1).replace(/\.0$/, "") + " Cr";
  if (n >= 100000) return (n / 100000).toFixed(1).replace(/\.0$/, "") + " L";
  if (n >= 1000) return (n / 1000).toFixed(1).replace(/\.0$/, "") + " K";
  return String(n);
};

const getCategoryText = (type) => {
  const raw = (type || "")
    .replace(/\s+/g, " ")
    .replace(/-/g, " ")
    .replace(/\//g, " ")
    .trim()
    .toLowerCase();
  if (raw === "buy") return "FOR BUY";
  if (raw === "rent") return "FOR RENT";
  if (raw.includes("commercial buy")) return "COMMERCIAL BUY";
  if (raw.includes("commercial lease")) return "COMMERCIAL LEASE";
  if (raw.includes("pg") || raw.includes("co living") || raw.includes("coliving"))
    return "PG / CO-LIVING";
  if (raw.includes("residential")) return "RESIDENTIAL";
  return "UNKNOWN";
};

const getListedPrice = (property) => {
  const isRent = property.property_category_type === "Rent";
  const primary = isRent ? property.rent : property.property_price;
  return primary ?? property.property_price ?? property.rent ?? null;
};

const hasValidCoords = (p) =>
  p.latitude !== null &&
  p.longitude !== null &&
  !isNaN(parseFloat(p.latitude)) &&
  !isNaN(parseFloat(p.longitude));

const isCommercialLease = (f) =>
  f.propertyType === "Commercial Lease" && f.buildingType === "Commercial";

const mapCommercialTypes = ({ propertyTypes, plotLandTypes }) => {
  const property_type = [];
  const office_type = [];
  const sub_sub_property_type = [];
  propertyTypes.forEach((raw) => {
    const val = raw.trim();
    if (val === "Plot/Land") {
      property_type.push("Plot/Land");
      office_type.push(...plotLandTypes);
    } else if (val === "Retail") {
      property_type.push("Retail");
    } else if (val === "Others") {
      sub_sub_property_type.push("Others");
    } else {
      office_type.push(val);
    }
  });
  return { property_type, office_type, sub_sub_property_type };
};

const mapCommercialLeaseTypes = (f) => {
  const property_type = [];
  const office_type = [];
  const sub_sub_property_type = [];
  f.propertyTypes.forEach((type) => {
    if (type === "Office Space") {
      property_type.push("Office");
      office_type.push(...f.officeType);
    } else if (type === "Retail Shops/Showrooms") {
      property_type.push("Retail");
      sub_sub_property_type.push(...f.retailType);
    } else if (type === "Other Commercial spaces") {
      f.otherCommercialType.forEach((item) => {
        if (item === "Others") sub_sub_property_type.push("Others");
        else office_type.push(item);
      });
    } else if (type === "Plot/Land") {
      property_type.push("Plot/Land");
      office_type.push(...f.plotLandTypes);
    }
  });
  return { property_type, office_type, sub_sub_property_type };
};

const appendPropertyTypeParams = (fd, f) => {
  let mapped = null;
  if (isCommercialLease(f)) mapped = mapCommercialLeaseTypes(f);
  else if (f.propertyType === "Commercial Buy") mapped = mapCommercialTypes(f);

  if (mapped) {
    if (mapped.property_type.length)
      fd.append("property_type", mapped.property_type.join(","));
    if (mapped.office_type.length)
      fd.append("office_type", mapped.office_type.join(","));
    if (mapped.sub_sub_property_type.length)
      fd.append("sub_sub_property_type", mapped.sub_sub_property_type.join(","));
  } else if (f.propertyTypes.length) {
    fd.append("property_type", f.propertyTypes.join(","));
  }
};

// Shared by the listing request and the save-search request
const appendFilterParams = (fd, f, { userType, bathroomKey }) => {
  if (f.buildingType) fd.append("building_type", f.buildingType);

  if (f.propertyType) {
    const apiCategory =
      f.propertyType === "Commercial Buy"
        ? "Buy"
        : f.propertyType === "Commercial Lease"
          ? "Rent"
          : f.propertyType;
    fd.append("property_category_type", apiCategory);
  }

  appendPropertyTypeParams(fd, f);

  if (f.bhkType) fd.append("bhk_type", f.bhkType);
  if (f.furnishedStatus) fd.append("furnished_type", f.furnishedStatus);
  if (f.minPrice) fd.append("min_price", f.minPrice);
  if (f.maxPrice) fd.append("max_price", f.maxPrice);
  if (f.minArea) fd.append("min_area", f.minArea);
  if (f.maxArea) fd.append("max_area", f.maxArea);
  if ((f.minArea || f.maxArea) && f.areaIn) fd.append("area_in", f.areaIn);
  if (userType) fd.append("user_type", userType);

  if (f.constructionStatus.length)
    fd.append("construction_status", f.constructionStatus.join(","));
  if (f.amenities.length) fd.append("amenities", f.amenities.join(","));
  if (f.bathrooms) fd.append(bathroomKey, f.bathrooms);
  if (f.facing) fd.append("facing", f.facing);
  if (f.withPhoto) fd.append("with_photo", f.withPhoto);
  if (f.withVideos) fd.append("with_videos", f.withVideos);

  if (f.availableFor.length) fd.append("available_for", f.availableFor.join(","));
  if (f.sharingType.length) fd.append("sharing_type", f.sharingType.join(","));
  if (f.availableFrom.length) fd.append("available_from", f.availableFrom.join(","));
  if (f.capacity.length)
    fd.append("available_beds", f.capacity.map((c) => CAPACITY_MAP[c]).join(","));

  if (f.investmentOptions.length)
    fd.append("investment_options", f.investmentOptions.join(","));
  if (f.purchaseType) fd.append("purchase_type", f.purchaseType);
};

// ============================================================
// SUB-COMPONENTS
// ============================================================

const MapPanner = ({ target }) => {
  const map = useMap();
  useEffect(() => {
    if (!target) return;
    map.flyTo([target.lat, target.lng], Math.max(map.getZoom(), 12), {
      duration: 0.8,
    });
  }, [target, map]);
  return null;
};

// Multi-select dropdown in the same style as the Search dashboard
const MultiDropdown = ({
  id,
  placeholder,
  options,
  selected,
  onToggle,
  onClear,
  openDropdown,
  setOpenDropdown,
  radio = false,
  className = "",
}) => {
  const isOpen = openDropdown === id;
  const selectedLabels = options
    .filter((o) => selected.includes(o.value))
    .map((o) => o.label);
  const summary =
    selectedLabels.length === 0
      ? placeholder
      : selectedLabels.length === 1
        ? selectedLabels[0]
        : `${selectedLabels.length} selected`;

  return (
    <div className={`relative ${className}`}>
      <button
        type="button"
        onClick={() => setOpenDropdown(isOpen ? null : id)}
        className={btnCls}
      >
        <span className="truncate text-gray-700">{summary}</span>
        <RiArrowDropDownLine className="text-lg text-gray-500" />
      </button>

      {isOpen && (
        <div className={`${panelCls} max-h-60 overflow-y-auto`}>
          {options.map((o) => (
            <label
              key={o.value}
              className="flex items-center gap-2 px-3 py-2 hover:bg-[#8B1E3F]/5 cursor-pointer text-sm"
            >
              <input
                type={radio ? "radio" : "checkbox"}
                name={id}
                checked={selected.includes(o.value)}
                onChange={() => onToggle(o.value)}
                className="accent-[#8B1E3F]"
              />
              {o.label}
            </label>
          ))}
          <div className="sticky bottom-0 flex gap-2 p-2 border-t bg-white">
            <button
              type="button"
              onClick={onClear}
              className="flex-1 py-1.5 text-xs border rounded-md hover:bg-gray-50"
            >
              Clear
            </button>
            <button
              type="button"
              onClick={() => setOpenDropdown(null)}
              className="flex-1 py-1.5 text-xs text-white bg-[#8B1E3F] rounded-md hover:bg-[#7a1a37]"
            >
              Done
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

// ============================================================
// MAIN COMPONENT
// ============================================================

export default function AdvisorDashboard() {
  const location = useLocation();
  const label = new URLSearchParams(location.search).get("label");
  const accessToken = sessionStorage.getItem("accessToken");

  const { searchCity, setSearchCity } = useCity();

  // ---------- Listing state ----------
  const [properties, setProperties] = useState([]);
  const [loading, setLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [filters, setFilters] = useState(() => ({
    ...initialFilters,
    postedBy: label || "",
  }));
  const filterSignature = JSON.stringify(filters);

  // ---------- UI state ----------
  const [hoveredPropertyId, setHoveredPropertyId] = useState(null);
  const [panTarget, setPanTarget] = useState(null);
  const [activeIndexes, setActiveIndexes] = useState({});
  const [openDropdown, setOpenDropdown] = useState(null);
  const [showMoreFilters, setShowMoreFilters] = useState(false);
  const [locationInput, setLocationInput] = useState("");
  const locationInputRef = useRef(null);

  // ---------- Amenities ----------
  const [amenitiesList, setAmenitiesList] = useState([]);

  // ---------- Share / contact / auth ----------
  const [currentShareUrl, setCurrentShareUrl] = useState("");
  const [isShareModalOpen, setIsShareModalOpen] = useState(false);
  const [selectedProperty, setSelectedProperty] = useState(null);
  const [isContactModalOpen, setIsContactModalOpen] = useState(false);
  const [freeViewCount, setFreeViewCount] = useState(0);
  const [paidViewCount, setPaidViewCount] = useState(0);
  const [showUpgradePrompt, setShowUpgradePrompt] = useState(false);
  const [isLoginModalOpen, setIsLoginModalOpen] = useState(false);
  const [isSignUpModalOpen, setIsSignUpModalOpen] = useState(false);

  // ---------- Derived ----------
  const cityFromSession = sessionStorage.getItem("cityName");
  const selectedLocations = parseCities(searchCity || cityFromSession || "");
  const canAddLocation = selectedLocations.length < 3;

  // Keep a ref to the latest addLocation so Google's listener never goes stale
  const addLocationRef = useRef(null);

  // ============================================================
  // FILTER HELPERS
  // ============================================================

  const updateFilters = (patch) => {
    setFilters((prev) => ({ ...prev, ...patch }));
    setCurrentPage(1);
  };

  const toggleList = (key, value) => {
    setFilters((prev) => ({
      ...prev,
      [key]: prev[key].includes(value)
        ? prev[key].filter((v) => v !== value)
        : [...prev[key], value],
    }));
    setCurrentPage(1);
  };

  const clearList = (key) => updateFilters({ [key]: [] });

  // Radio behaviour for Commercial Lease property types
  const togglePropertyType = (type) => {
    setFilters((prev) => {
      if (isCommercialLease(prev)) {
        return { ...prev, propertyTypes: [type] };
      }
      return {
        ...prev,
        propertyTypes: prev.propertyTypes.includes(type)
          ? prev.propertyTypes.filter((t) => t !== type)
          : [...prev.propertyTypes, type],
      };
    });
    setCurrentPage(1);
  };

  const handleCategoryChange = (val) => {
    const commercial = val === "Commercial Buy" || val === "Commercial Lease";
    updateFilters({
      propertyType: val,
      buildingType: commercial ? "Commercial" : "",
      propertyTypes: [],
      officeType: [],
      retailType: [],
      otherCommercialType: [],
      plotLandTypes: [],
    });
  };

  const handleResetFilters = () => {
    setFilters({ ...initialFilters, postedBy: label || "" });
    setOpenDropdown(null);
    setCurrentPage(1);
  };

  const incrementBathrooms = () => {
    const cur = parseInt(filters.bathrooms) || 0;
    if (cur < 20) updateFilters({ bathrooms: String(cur + 1) });
  };

  const decrementBathrooms = () => {
    const cur = parseInt(filters.bathrooms) || 0;
    updateFilters({ bathrooms: cur > 0 ? String(cur - 1) : "" });
  };

  const handleBathroomInput = (e) => {
    const value = e.target.value;
    if (value === "") return updateFilters({ bathrooms: "" });
    const n = parseInt(value);
    if (!isNaN(n) && n >= 0 && n <= 20) updateFilters({ bathrooms: String(n) });
  };

  const getFilteredPropertyTypes = () => {
    if (isCommercialLease(filters)) {
      return ["Office Space", "Retail Shops/Showrooms", "Other Commercial spaces", "Plot/Land"];
    }
    if (filters.propertyType === "Commercial Buy" || filters.buildingType === "Commercial") {
      return COMMERCIAL_BUY_TYPES;
    }
    if (filters.propertyType === "Buy") {
      return ["Flat/Apartment", "Home/Villa", "Service Apartment", "Farmhouse", "Plot/Land", "Builder Floor", "1RK/Studio Apartment"];
    }
    if (filters.propertyType === "Rent") {
      return ["Flat/Apartment", "Builder Floor", "1RK/Studio Apartment", "Independent House/Villa", "Service Apartment", "Farmhouse"];
    }
    if (filters.propertyType === "PG/Co-living") {
      return ["Flat/Apartment", "Builder Floor", "1RK/Studio Apartment", "Independent House/Villa", "Service Apartment"];
    }
    return [
      "Apartment", "Flat/Apartment", "Builder Floor", "Independent House/Villa",
      "Independent/Builder Floor", "1RK/Studio Apartment", "Service Apartment",
      "Farmhouse", "Office", "Retail", "Plot/Land", "Storage", "Industry",
      "Hospitality", "Other", "Home/Villa",
    ];
  };

  const getAvailableForOptions = () => {
    if (filters.propertyType === "Rent")
      return ["Family", "Single Women", "Single Men", "Company Guest House"];
    if (filters.propertyType === "PG/Co-living") return ["Boys", "Girls", "Working"];
    return [];
  };

  const showPlotLand =
    (filters.propertyType === "Commercial Buy" || isCommercialLease(filters)) &&
    filters.propertyTypes.includes("Plot/Land");
  const showFacing = filters.propertyTypes.includes("Plot/Land");
  const isPG = filters.propertyType === "PG/Co-living";
  const isRent = filters.propertyType === "Rent";
  const isCommercialBuy = filters.propertyType === "Commercial Buy";
  const showOffice = isCommercialLease(filters) && filters.propertyTypes.includes("Office Space");
  const showRetail = isCommercialLease(filters) && filters.propertyTypes.includes("Retail Shops/Showrooms");
  const showOther = isCommercialLease(filters) && filters.propertyTypes.includes("Other Commercial spaces");

  // ============================================================
  // DATA LOADING
  // ============================================================

  const loadProperties = async () => {
    try {
      setLoading(true);

      const fd = new FormData();
      fd.append("page", currentPage);
      fd.append("page_size", ITEMS_PER_PAGE);
      if (accessToken) fd.append("customer_id", accessToken);

      const cityToUse = selectedLocations.join(", ");
      if (cityToUse) fd.append("city_name", cityToUse);

      appendFilterParams(fd, filters, {
        userType: filters.postedBy || label || "",
        bathroomKey: "number_of_minimum_bathrooms",
      });

      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/cust_api/filter_property`,
        fd,
        { headers: { "Content-Type": "multipart/form-data" } },
      );

      if (response.status === 200 && response.data.status === 1) {
        setProperties(response.data.data || []);
        setTotalPages(response.data.total_pages || 1);
      } else {
        setProperties([]);
        setTotalPages(1);
      }
    } catch (err) {
      console.error("Load Properties Error:", err);
      setProperties([]);
      setTotalPages(1);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadProperties();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [label, currentPage, searchCity, filterSignature]);

  useEffect(() => {
    if (label) setFilters((prev) => ({ ...prev, postedBy: label }));
  }, [label]);

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, [currentPage]);

  useEffect(() => {
    const fetchAmenities = async () => {
      try {
        const res = await axios.post(
          "https://api.nowaybroker.com/cust_api/get_amenities",
          new FormData(),
        );
        if (res.data.status === 1) setAmenitiesList(res.data.data);
      } catch (err) {
        console.log("Amenities fetch failed", err);
      }
    };
    fetchAmenities();
  }, []);

  // ============================================================
  // LOCATION BAR
  // ============================================================

  const addLocation = (name) => {
    const trimmed = name.trim();
    if (!trimmed) return;
    if (selectedLocations.includes(trimmed)) {
      setLocationInput("");
      return;
    }
    if (selectedLocations.length >= 3) {
      toast.error("You can select a maximum of 3 locations.");
      return;
    }
    setSearchCity([...selectedLocations, trimmed].join(", "));
    setCurrentPage(1);
    setLocationInput("");
  };

  const removeLocation = (loc) => {
    setSearchCity(selectedLocations.filter((l) => l !== loc).join(", "));
    setCurrentPage(1);
  };

  addLocationRef.current = addLocation;

  const handleLocationKeyDown = (e) => {
    if (e.key === "Enter" && locationInput.trim()) {
      e.preventDefault();
      addLocation(locationInput);
    }
  };

  // Google Places autocomplete (re-attaches when the input re-mounts)
  useEffect(() => {
    if (!canAddLocation) return;

    const init = () => {
      if (!locationInputRef.current || !window.google?.maps?.places) return;
      const ac = new window.google.maps.places.Autocomplete(locationInputRef.current, {
        types: ["(cities)"],
        componentRestrictions: { country: "in" },
      });
      ac.addListener("place_changed", () => {
        const place = ac.getPlace();
        if (place?.name) addLocationRef.current(place.name);
      });
    };

    if (window.google?.maps?.places) {
      init();
    } else {
      let script = document.getElementById("gmaps-places-script");
      if (!script) {
        script = document.createElement("script");
        script.id = "gmaps-places-script";
        script.src = `https://maps.googleapis.com/maps/api/js?key=${process.env.REACT_APP_GOOGLE_MAPS_KEY}&libraries=places`;
        script.async = true;
        script.defer = true;
        document.body.appendChild(script);
      }
      script.addEventListener("load", init);
    }
  }, [canAddLocation]);

  // ============================================================
  // FAVORITES
  // ============================================================

  const addToFavorites = async (propertyId) => {
    if (!accessToken) {
      toast.error("You must be logged in to perform this action");
      return;
    }
    try {
      await axios.post(`${process.env.REACT_APP_API_URL}/cust_api/add_to_favorite`, {
        user_id: accessToken,
        property_id: propertyId,
      });
    } catch (err) {
      console.error("Error adding property to favorites:", err);
    } finally {
      loadProperties();
    }
  };

  const removeFromFavorites = async (favoriteId) => {
    const fd = new FormData();
    fd.append("favorite_id", favoriteId);
    try {
      const response = await axios.delete(
        `${process.env.REACT_APP_API_URL}/cust_api/remove_from_favorite`,
        { data: fd },
      );
      if (response.data.status !== 1) {
        console.error("Failed to remove:", response.data.message);
      }
    } catch (err) {
      console.error("Error unfavoriting:", err);
    } finally {
      loadProperties();
    }
  };

  // ============================================================
  // SHARE
  // ============================================================

  const openShareModal = (url) => {
    setCurrentShareUrl(url);
    setIsShareModalOpen(true);
  };

  const handleCloseShareModal = () => setIsShareModalOpen(false);

  const copyShareLink = () => {
    const url = currentShareUrl;
    const fallbackCopy = (text) => {
      const ta = document.createElement("textarea");
      ta.value = text;
      ta.style.position = "fixed";
      ta.style.left = "-9999px";
      document.body.appendChild(ta);
      ta.focus();
      ta.select();
      try {
        document.execCommand("copy");
        alert("Link copied!");
      } catch {
        alert("Copy failed");
      }
      document.body.removeChild(ta);
    };

    if (navigator.clipboard && window.isSecureContext) {
      navigator.clipboard
        .writeText(url)
        .then(() => alert("Link copied!"))
        .catch(() => fallbackCopy(url));
    } else {
      fallbackCopy(url);
    }
  };

  // ============================================================
  // SAVE SEARCH
  // ============================================================

  const handleSaveSearch = async () => {
    if (!accessToken) {
      toast.error("Please login first to save search.");
      setIsLoginModalOpen(true);
      return;
    }
    try {
      const fd = new FormData();
      fd.append("user_id", accessToken);
      fd.append(
        "property_id",
        properties.map((p) => p._id || "").join("|"),
      );
      fd.append(
        "property_name",
        properties.map((p) => p.property_name || "").join("|"),
      );
      fd.append(
        "property_category_type",
        properties.map((p) => p.property_category_type || "").join("|"),
      );
      fd.append(
        "building_type",
        properties.map((p) => p.building_type || "").join("|"),
      );

      const citiesStr = selectedLocations.join(", ");
      fd.append("city_name", citiesStr || cityFromSession || "");
      fd.append("search_keyword", citiesStr || "");

      appendFilterParams(fd, filters, {
        userType: filters.postedBy,
        bathroomKey: "no_of_bathrooms",
      });

      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/cust_api/add_save_search_property`,
        { method: "POST", body: fd },
      );
      const result = await response.json();
      if (response.ok && result.status === 1) {
        toast.success("Search saved successfully!");
      } else {
        toast.error(result.message || "Failed to save search.");
      }
    } catch (err) {
      console.error("Save Search Error:", err);
      toast.error("Something went wrong.");
    }
  };

  // ============================================================
  // CONTACT LIMITS
  // ============================================================

  const checkPostLimits = async () => {
    try {
      const profileForm = new FormData();
      profileForm.append("user_id", accessToken);
      const res = await axios.post(
        `${process.env.REACT_APP_API_URL}/cust_api/get_profile`,
        profileForm,
        { headers: { "Content-Type": "multipart/form-data" } },
      );
      const countData = res?.data?.count_data;
      if (countData) {
        setFreeViewCount(countData.free_view_count || 0);
        setPaidViewCount(countData.paid_view_count || 0);
      }
    } catch (err) {
      console.error("Error checking post limits:", err);
    }
  };

  useEffect(() => {
    if (accessToken) checkPostLimits();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [accessToken]);

  const handleAddCount = async () => {
    try {
      const fd = new FormData();
      if (freeViewCount > 0) fd.append("free_view_count", -1);
      else fd.append("paid_view_count", -1);
      fd.append("user_id", accessToken);
      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/cust_api/add_count`,
        { method: "POST", body: fd },
      );
      if (response.ok) checkPostLimits();
    } catch (err) {
      console.error("API error:", err);
    }
  };

  const handleContactClick = async (property) => {
    if (!accessToken) {
      setIsLoginModalOpen(true);
      return;
    }
    setSelectedProperty(property);
    if (freeViewCount > 0 || paidViewCount > 0) {
      await handleAddCount();
      setShowUpgradePrompt(false);
    } else {
      setShowUpgradePrompt(true);
    }
    setIsContactModalOpen(true);
  };

  // ============================================================
  // MAP
  // ============================================================

  const createCustomIcon = (price, isActive = false) =>
    L.divIcon({
      className: `custom-marker ${isActive ? "active" : ""}`,
      html: `
        <div class="marker-wrapper">
          <div class="price-tooltip">
            ${formatPrice(price)}
            <div class="pointer"></div>
          </div>
        </div>
      `,
      iconSize: [50, 60],
      iconAnchor: [25, 60],
    });

  const isMarkerActive = (id) => id === hoveredPropertyId;

  const handleCardEnter = (property) => {
    setHoveredPropertyId(property._id);
    const lat = parseFloat(property.latitude);
    const lng = parseFloat(property.longitude);
    if (!isNaN(lat) && !isNaN(lng)) setPanTarget({ lat, lng });
  };

  const handleCardLeave = () => setHoveredPropertyId(null);

  const handlePageChange = (page) => {
    if (page >= 1 && page <= totalPages) setCurrentPage(page);
  };

  const getPaginationRange = () => {
    const range = [];
    const groupSize = 3;
    const groupStart = Math.floor((currentPage - 1) / groupSize) * groupSize + 1;
    const groupEnd = Math.min(groupStart + groupSize - 1, totalPages);
    for (let i = groupStart; i <= groupEnd; i++) range.push(i);
    if (groupEnd < totalPages) {
      range.push("...");
      range.push(totalPages);
    }
    return range;
  };

  const validProperties = properties.filter(hasValidCoords);
  const mapCenter =
    validProperties.length > 0
      ? [parseFloat(validProperties[0].latitude), parseFloat(validProperties[0].longitude)]
      : DEFAULT_CENTER;

  const amenityOptions = amenitiesList.map((a) => ({
    value: String(a._id),
    label: a.amenity_name,
  }));

  // ============================================================
  // RENDER
  // ============================================================

  return (
    <>
      {/* ===================== LOCATION BAR ===================== */}
     

      {/* ===================== FILTERS ===================== */}
      <div className="bg-white rounded-xl border border-gray-200 shadow-sm relative z-20 mb-4 mx-4 sm:mx-6">
        <div className="p-2">
          <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-7 gap-1.5">
            {/* Category */}
            <div>
              <select
                value={filters.propertyType}
                onChange={(e) => handleCategoryChange(e.target.value)}
                onFocus={() => setOpenDropdown(null)}
                className={`w-full ${selectCls}`}
              >
                <option value="">Property Category</option>
                <option value="Buy">Buy</option>
                <option value="Rent">Rent</option>
                <option value="Commercial Buy">Commercial Buy</option>
                <option value="Commercial Lease">Commercial Lease</option>
                <option value="PG/Co-living">PG / Co-living</option>
              </select>
            </div>

            {/* Building Type */}
            <div>
              <select
                value={filters.buildingType}
                onChange={(e) => updateFilters({ buildingType: e.target.value })}
                onFocus={() => setOpenDropdown(null)}
                disabled={isCommercialBuy || isCommercialLease(filters)}
                className={`w-full ${selectCls} disabled:opacity-50 disabled:cursor-not-allowed`}
              >
                <option value="">Building Type</option>
                <option value="Residential">Residential</option>
                <option value="Commercial">Commercial</option>
              </select>
            </div>

            {/* Property Type */}
            <MultiDropdown
              id="propertyType"
              placeholder="Property Type"
              options={asOptions(getFilteredPropertyTypes())}
              selected={filters.propertyTypes}
              onToggle={togglePropertyType}
              onClear={() => clearList("propertyTypes")}
              openDropdown={openDropdown}
              setOpenDropdown={setOpenDropdown}
              radio={isCommercialLease(filters)}
            />

            {/* Budget */}
            <div className="relative">
              <button
                type="button"
                onClick={() => setOpenDropdown(openDropdown === "budget" ? null : "budget")}
                className={btnCls}
              >
                <span className="truncate text-gray-700">
                  {filters.minPrice && filters.maxPrice
                    ? `${formatPriceMinMax(filters.minPrice)} - ${formatPriceMinMax(filters.maxPrice)}`
                    : filters.minPrice
                      ? `Above ${formatPriceMinMax(filters.minPrice)}`
                      : filters.maxPrice
                        ? `Below ${formatPriceMinMax(filters.maxPrice)}`
                        : "Budget"}
                </span>
                <RiArrowDropDownLine className="text-lg text-gray-500" />
              </button>

              {openDropdown === "budget" && (
                <div className={`${panelCls} p-3 space-y-2`}>
                  <div>
                    <label className="text-xs text-gray-500 mb-1 block">Min Price</label>
                    <select
                      value={filters.minPrice}
                      onChange={(e) => updateFilters({ minPrice: e.target.value })}
                      className="w-full p-2 text-sm border border-gray-300 rounded-md focus:outline-none focus:ring-1 focus:ring-[#8B1E3F]"
                    >
                      <option value="">Min</option>
                      {PRICE_OPTIONS.filter((p) => !filters.maxPrice || p < Number(filters.maxPrice)).map((p) => (
                        <option key={p} value={p}>{formatPriceMinMax(p)}</option>
                      ))}
                    </select>
                  </div>
                  <div>
                    <label className="text-xs text-gray-500 mb-1 block">Max Price</label>
                    <select
                      value={filters.maxPrice}
                      onChange={(e) => updateFilters({ maxPrice: e.target.value })}
                      className="w-full p-2 text-sm border border-gray-300 rounded-md focus:outline-none focus:ring-1 focus:ring-[#8B1E3F]"
                    >
                      <option value="">Max</option>
                      {PRICE_OPTIONS.filter((p) => !filters.minPrice || p > Number(filters.minPrice)).map((p) => (
                        <option key={p} value={p}>{formatPriceMinMax(p)}</option>
                      ))}
                    </select>
                  </div>
                </div>
              )}
            </div>

            {/* BHK */}
            <div>
              <select
                value={filters.bhkType}
                onChange={(e) => updateFilters({ bhkType: e.target.value })}
                onFocus={() => setOpenDropdown(null)}
                className={`w-full ${selectCls}`}
              >
                <option value="">BHK</option>
                {BHK_OPTIONS.map((b) => (
                  <option key={b} value={b}>{b}</option>
                ))}
              </select>
            </div>

            {/* More Filters */}
            <div>
              <button
                type="button"
                onClick={() => {
                  setShowMoreFilters(!showMoreFilters);
                  setOpenDropdown(null);
                }}
                className={`flex items-center justify-center gap-1 w-full h-8 px-2 text-xs font-medium rounded-lg border transition-all ${
                  showMoreFilters
                    ? "bg-[#8B1E3F] text-white border-[#8B1E3F]"
                    : "bg-white text-gray-700 border-gray-300 hover:border-[#8B1E3F] hover:text-[#8B1E3F]"
                }`}
              >
                <span>More Filters</span>
                <RiArrowDropDownLine
                  className={`text-lg transition-transform ${showMoreFilters ? "rotate-180" : ""}`}
                />
              </button>
            </div>

            {/* Reset + Save */}
            <div className="flex items-center gap-1.5">
              <button
                type="button"
                onClick={handleResetFilters}
                className="h-8 flex-1 px-2 text-xs font-medium text-[#8B1E3F] border border-[#8B1E3F] rounded-lg hover:bg-[#8B1E3F]/5 transition-colors"
              >
                Reset
              </button>
              <button
                type="button"
                onClick={handleSaveSearch}
                className="h-8 flex-1 px-2 text-xs font-medium text-white bg-[#8B1E3F] rounded-lg hover:bg-[#7a1a37] transition-colors"
              >
                Save
              </button>
            </div>
          </div>
        </div>

        {/* MORE FILTERS EXPANDED */}
        {showMoreFilters && (
          <div className="border-t border-gray-200 bg-gray-50/70 p-3">
            <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 xl:grid-cols-6 gap-2.5">
              {/* Furnished */}
              <select
                value={filters.furnishedStatus}
                onChange={(e) => updateFilters({ furnishedStatus: e.target.value })}
                onFocus={() => setOpenDropdown(null)}
                className={selectCls}
              >
                <option value="">Furnished</option>
                <option value="Furnished">Furnished</option>
                <option value="Semi-Furnished">Semi-Furnished</option>
                <option value="Unfurnished">Unfurnished</option>
              </select>

              {/* Posted By */}
              <select
                value={filters.postedBy}
                onChange={(e) => updateFilters({ postedBy: e.target.value })}
                onFocus={() => setOpenDropdown(null)}
                className={selectCls}
              >
                <option value="">Posted By</option>
                <option value="Owner">Owner</option>
                <option value="Builder">Builder</option>
              </select>

              {/* Construction */}
              <MultiDropdown
                id="construction"
                placeholder="Construction"
                options={asOptions(["Ready To Move", "New Launch", "Under Construction"])}
                selected={filters.constructionStatus}
                onToggle={(v) => toggleList("constructionStatus", v)}
                onClear={() => clearList("constructionStatus")}
                openDropdown={openDropdown}
                setOpenDropdown={setOpenDropdown}
              />

              {/* Amenities */}
              <MultiDropdown
                id="amenities"
                placeholder="Amenities"
                options={amenityOptions}
                selected={filters.amenities}
                onToggle={(v) => toggleList("amenities", v)}
                onClear={() => clearList("amenities")}
                openDropdown={openDropdown}
                setOpenDropdown={setOpenDropdown}
              />

              {/* Bathrooms */}
              <div className="flex items-center h-8 border border-gray-300 rounded-lg overflow-hidden bg-white hover:border-[#8B1E3F] transition-colors">
                <button
                  type="button"
                  onClick={decrementBathrooms}
                  className="w-8 h-full flex items-center justify-center border-r hover:bg-gray-50 text-base"
                >
                  −
                </button>
                <input
                  type="number"
                  min="0"
                  max="20"
                  value={filters.bathrooms}
                  onChange={handleBathroomInput}
                  onFocus={() => setOpenDropdown(null)}
                  placeholder="Bath"
                  className="w-full h-full text-center text-xs focus:outline-none"
                />
                <button
                  type="button"
                  onClick={incrementBathrooms}
                  className="w-8 h-full flex items-center justify-center border-l hover:bg-gray-50 text-base"
                >
                  +
                </button>
              </div>

              {/* Facing (plot/land only) */}
              {showFacing && (
                <select
                  value={filters.facing}
                  onChange={(e) => updateFilters({ facing: e.target.value })}
                  onFocus={() => setOpenDropdown(null)}
                  className={selectCls}
                >
                  <option value="">Facing</option>
                  {FACING_OPTIONS.map((f) => (
                    <option key={f} value={f}>{f}</option>
                  ))}
                </select>
              )}

              {/* With Photo */}
              <select
                value={filters.withPhoto}
                onChange={(e) => updateFilters({ withPhoto: e.target.value })}
                onFocus={() => setOpenDropdown(null)}
                className={selectCls}
              >
                <option value="">With Photo</option>
                <option value="Yes">Yes</option>
                <option value="No">No</option>
              </select>

              {/* With Video */}
              <select
                value={filters.withVideos}
                onChange={(e) => updateFilters({ withVideos: e.target.value })}
                onFocus={() => setOpenDropdown(null)}
                className={selectCls}
              >
                <option value="">With Video</option>
                <option value="Yes">Yes</option>
                <option value="No">No</option>
              </select>

              {/* Area */}
              <div className="relative">
                <button
                  type="button"
                  onClick={() => setOpenDropdown(openDropdown === "area" ? null : "area")}
                  className={btnCls}
                >
                  <span className="truncate text-gray-700">
                    {filters.minArea || filters.maxArea
                      ? `${filters.minArea || 0} - ${filters.maxArea || "Any"} ${filters.areaIn}`
                      : "Area"}
                  </span>
                  <RiArrowDropDownLine className="text-lg text-gray-500" />
                </button>

                {openDropdown === "area" && (
                  <div className={`${panelCls} p-3 space-y-2`}>
                    <select
                      value={filters.areaIn}
                      onChange={(e) => updateFilters({ areaIn: e.target.value })}
                      className="w-full p-2 text-xs border border-gray-300 rounded-md"
                    >
                      {AREA_UNITS.map((u) => (
                        <option key={u} value={u}>{u}</option>
                      ))}
                    </select>
                    <input
                      type="number"
                      value={filters.minArea}
                      onChange={(e) => updateFilters({ minArea: e.target.value })}
                      placeholder="Min Area"
                      className="w-full p-2 text-xs border border-gray-300 rounded-md"
                    />
                    <input
                      type="number"
                      value={filters.maxArea}
                      onChange={(e) => updateFilters({ maxArea: e.target.value })}
                      placeholder="Max Area"
                      className="w-full p-2 text-xs border border-gray-300 rounded-md"
                    />
                    <button
                      type="button"
                      onClick={() => setOpenDropdown(null)}
                      className="w-full py-1.5 text-xs text-white bg-[#8B1E3F] rounded-md hover:bg-[#7a1a37]"
                    >
                      Done
                    </button>
                  </div>
                )}
              </div>

              {/* Rent: Available From */}
              {isRent && (
                <MultiDropdown
                  id="availableFrom"
                  placeholder="Available From"
                  options={asOptions([
                    "Immediately", "Any Time", "Within 1 Month",
                    "After 1 Month", "Within 3 Month", "After 3 Month",
                  ])}
                  selected={filters.availableFrom}
                  onToggle={(v) => toggleList("availableFrom", v)}
                  onClear={() => clearList("availableFrom")}
                  openDropdown={openDropdown}
                  setOpenDropdown={setOpenDropdown}
                />
              )}

              {/* Rent / PG: Available For */}
              {(isRent || isPG) && (
                <MultiDropdown
                  id="availableFor"
                  placeholder="Available For"
                  options={asOptions(getAvailableForOptions())}
                  selected={filters.availableFor}
                  onToggle={(v) => toggleList("availableFor", v)}
                  onClear={() => clearList("availableFor")}
                  openDropdown={openDropdown}
                  setOpenDropdown={setOpenDropdown}
                />
              )}

              {/* PG: Sharing Type */}
              {isPG && (
                <MultiDropdown
                  id="sharingType"
                  placeholder="Sharing Type"
                  options={asOptions(["Private Rooms", "2 Per Room", "More than 2 per room"])}
                  selected={filters.sharingType}
                  onToggle={(v) => toggleList("sharingType", v)}
                  onClear={() => clearList("sharingType")}
                  openDropdown={openDropdown}
                  setOpenDropdown={setOpenDropdown}
                />
              )}

              {/* PG: Total Capacity */}
              {isPG && (
                <MultiDropdown
                  id="capacity"
                  placeholder="Total Capacity"
                  options={asOptions(CAPACITY_OPTIONS)}
                  selected={filters.capacity}
                  onToggle={(v) => toggleList("capacity", v)}
                  onClear={() => clearList("capacity")}
                  openDropdown={openDropdown}
                  setOpenDropdown={setOpenDropdown}
                />
              )}

              {/* Commercial Buy: Investment Options */}
              {isCommercialBuy && (
                <MultiDropdown
                  id="investment"
                  placeholder="Investment Options"
                  options={asOptions(INVESTMENT_OPTIONS)}
                  selected={filters.investmentOptions}
                  onToggle={(v) => toggleList("investmentOptions", v)}
                  onClear={() => clearList("investmentOptions")}
                  openDropdown={openDropdown}
                  setOpenDropdown={setOpenDropdown}
                />
              )}

              {/* Commercial Buy: Purchase Type */}
              {isCommercialBuy && (
                <select
                  value={filters.purchaseType}
                  onChange={(e) => updateFilters({ purchaseType: e.target.value })}
                  onFocus={() => setOpenDropdown(null)}
                  className={selectCls}
                >
                  <option value="">Purchase Type</option>
                  {PURCHASE_TYPE_OPTIONS.map((o) => (
                    <option key={o} value={o}>{o}</option>
                  ))}
                </select>
              )}

              {/* Plot/Land sub-types */}
              {showPlotLand && (
                <MultiDropdown
                  id="plotLand"
                  placeholder="Plot/Land Type"
                  options={asOptions(PLOT_LAND_OPTIONS)}
                  selected={filters.plotLandTypes}
                  onToggle={(v) => toggleList("plotLandTypes", v)}
                  onClear={() => clearList("plotLandTypes")}
                  openDropdown={openDropdown}
                  setOpenDropdown={setOpenDropdown}
                />
              )}

              {/* Commercial Lease: Office Type */}
              {showOffice && (
                <MultiDropdown
                  id="officeType"
                  placeholder="Office Type"
                  options={asOptions(OFFICE_OPTIONS)}
                  selected={filters.officeType}
                  onToggle={(v) => toggleList("officeType", v)}
                  onClear={() => clearList("officeType")}
                  openDropdown={openDropdown}
                  setOpenDropdown={setOpenDropdown}
                />
              )}

              {/* Commercial Lease: Retail Type */}
              {showRetail && (
                <MultiDropdown
                  id="retailType"
                  placeholder="Retail Type"
                  options={asOptions(RETAIL_OPTIONS)}
                  selected={filters.retailType}
                  onToggle={(v) => toggleList("retailType", v)}
                  onClear={() => clearList("retailType")}
                  openDropdown={openDropdown}
                  setOpenDropdown={setOpenDropdown}
                />
              )}

              {/* Commercial Lease: Other Commercial Type */}
              {showOther && (
                <MultiDropdown
                  id="otherCommercial"
                  placeholder="Other Commercial Type"
                  options={asOptions(OTHER_COMMERCIAL_OPTIONS)}
                  selected={filters.otherCommercialType}
                  onToggle={(v) => toggleList("otherCommercialType", v)}
                  onClear={() => clearList("otherCommercialType")}
                  openDropdown={openDropdown}
                  setOpenDropdown={setOpenDropdown}
                />
              )}
            </div>
          </div>
        )}
      </div>

      {/* ===================== STYLES ===================== */}
      <style>{`
        .zb-popup .leaflet-popup-content-wrapper { padding: 0; overflow: hidden; border-radius: 12px; box-shadow: 0 14px 32px -12px rgba(94,13,40,0.35); border: 1px solid #eadfd6; }
        .zb-popup .leaflet-popup-content { margin: 0 !important; width: auto !important; }
        .zb-popup .leaflet-popup-content p { margin: 0; }
        .zb-popup .leaflet-popup-tip { background: #fff; }
        .zb-popup a.leaflet-popup-close-button { top: 8px; right: 8px; width: 26px; height: 26px; line-height: 24px; border-radius: 6px; background: rgba(255,255,255,.95); color: #7a1235; font-size: 18px; text-align: center; padding: 0; z-index: 20; }
        .zb-map .leaflet-top.leaflet-left { top: 8px; left: 8px; }
        .zb-map .leaflet-control-zoom { border: none !important; box-shadow: 0 6px 16px -6px rgba(94,13,40,.4) !important; border-radius: 10px; overflow: hidden; }
        .zb-map .leaflet-control-zoom a { color: #7a1235; background: #fff; border-bottom: 1px solid #eadfd6; width: 34px; height: 34px; line-height: 34px; }
        .zb-map .leaflet-control-zoom a:hover { background: #fbf3ec; color: #5e0d28; }
        .zb-map .leaflet-control-attribution { font-size: 10px; background: rgba(255,255,255,.8); }

        .marker-wrapper { position: relative; display: flex; justify-content: center; align-items: center; }
        .custom-marker { display: flex; align-items: center; justify-content: center; }
        .price-tooltip { position: relative; background: #fff; color: #1f2937; padding: 5px 10px; border-radius: 16px; border: 1px solid #eadfd6; font-size: 12px; font-weight: 700; white-space: nowrap; box-shadow: 0 4px 12px rgba(0,0,0,.2); transition: background-color .2s ease, color .2s ease, border-color .2s ease, transform .2s ease; }
        .price-tooltip .pointer { position: absolute; bottom: -7px; left: 50%; transform: translateX(-50%); width: 0; height: 0; border-left: 7px solid transparent; border-right: 7px solid transparent; border-top: 7px solid #fff; }
        .custom-marker.active .price-tooltip { background: #7a1235; color: #fff; border-color: #7a1235; transform: scale(1.08); }
        .custom-marker.active .price-tooltip .pointer { border-top-color: #7a1235; }

        .zb-card .slick-slide img { transition: transform .6s ease; }
        .zb-card:hover .slick-slide img { transform: scale(1.05); }
        .zb-card .slick-prev, .zb-card .slick-next { z-index: 5; width: 28px; height: 28px; opacity: 0; transition: opacity .25s ease; }
        .zb-card .slick-prev { left: 8px; }
        .zb-card .slick-next { right: 8px; }
        .zb-card:hover .slick-prev, .zb-card:hover .slick-next { opacity: 1; }
        .zb-card .slick-prev:before, .zb-card .slick-next:before { font-size: 28px; text-shadow: 0 2px 6px rgba(0,0,0,.45); }
      `}</style>

      {/* ===================== LISTING + MAP ===================== */}
      <div className="flex flex-col p-2 space-y-4 sm:p-5 rounded-2xl bg-[#fbf3ec] mx-4 sm:mx-6 mb-6">
        <div className="flex-grow">
          <div className="flex flex-col bg-white border border-[#eadfd6] shadow-sm rounded-2xl sm:flex-row-reverse">
            {/* Properties List */}
            <div className="z-10 flex-1 p-3 sm:p-5 no-scrollbar" style={{ scrollbarWidth: "none" }}>
              <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 md:grid-cols-2">
                {loading ? (
                  <div className="py-10 text-center text-gray-700 col-span-full">
                    <p className="m-0">Loading properties...</p>
                  </div>
                ) : validProperties.length > 0 ? (
                  validProperties.map((property) => {
                    const total = 1 + (property?.property_images?.length || 0);
                    const active = (activeIndexes[property._id] || 0) % total;
                    const isRentCard = property.property_category_type === "Rent";
                    const isHovered = hoveredPropertyId === property._id;

                    return (
                      <div
                        key={property._id}
                        className={`zb-card group flex flex-col gap-2 transition-transform duration-300 ${
                          isHovered ? "-translate-y-0.5" : "hover:-translate-y-0.5"
                        }`}
                        onMouseEnter={() => handleCardEnter(property)}
                        onMouseLeave={handleCardLeave}
                      >
                        {/* Image Box */}
                        <div
                          className={`relative h-[130px] shrink-0 overflow-hidden rounded-xl bg-slate-900 transition-shadow duration-300 ${
                            isHovered ? "ring-2 ring-[#7a1235] shadow-lg" : "shadow-sm"
                          }`}
                        >
                          <Link
                            to={`/propertydetails/${property._id}`}
                            className="absolute inset-0 block overflow-hidden"
                          >
                            {total > 1 ? (
                              <Slider
                                dots={false}
                                arrows={false}
                                infinite
                                speed={600}
                                slidesToShow={1}
                                slidesToScroll={1}
                                autoplay
                                autoplaySpeed={2800}
                                beforeChange={(c, n) =>
                                  setActiveIndexes((prev) => ({ ...prev, [property._id]: n }))
                                }
                                initialSlide={activeIndexes[property._id] || 0}
                              >
                                <div>
                                  <img
                                    src={property.cover_image}
                                    alt="Cover"
                                    className="object-cover w-full h-[130px]"
                                  />
                                </div>
                                {(property?.property_images || []).map((img) => (
                                  <div key={img._id}>
                                    <img
                                      src={img.image}
                                      alt="Property"
                                      className="object-cover w-full h-[130px]"
                                    />
                                  </div>
                                ))}
                              </Slider>
                            ) : (
                              <img
                                src={property.cover_image}
                                alt="Cover"
                                className="object-cover w-full h-[130px] transition-transform duration-700 group-hover:scale-105"
                              />
                            )}
                          </Link>

                          <div className="absolute inset-x-0 top-0 h-12 pointer-events-none bg-gradient-to-b from-black/50 to-transparent" />

                          {/* Top-left badges */}
                          <div className="absolute z-10 flex flex-col items-start gap-1 pointer-events-none top-2 left-2">
                            <span className="px-1.5 py-0.5 text-[10px] font-medium text-white rounded bg-black/45 backdrop-blur">
                              {property.days_since_created} days on ZeroBriks
                            </span>
                            <div className="flex items-center gap-1">
                              <span className="px-1.5 py-0.5 text-[10px] font-semibold tracking-wide text-white rounded shadow bg-[#7a1235]">
                                {getCategoryText(property.property_category_type)}
                              </span>
                              {property.mark_as_featured === "Yes" && (
                                <span className="px-1.5 py-0.5 text-[10px] font-bold tracking-wide text-[#5e0d28] rounded shadow bg-[#e3b23c]">
                                  ★ FEATURED
                                </span>
                              )}
                            </div>
                          </div>

                          {/* Top-right: tour + favourite */}
                          <div className="absolute z-10 flex items-center gap-1 top-2 right-2">
                            {property.virtual_tour_availability === "Yes" && (
                              <span className="flex items-center gap-1 px-1.5 py-0.5 text-[10px] font-medium text-white rounded-full pointer-events-none bg-black/45 backdrop-blur">
                                <PiCubeFocus className="text-xs text-[#e3b23c]" /> Tour
                              </span>
                            )}
                            <button
                              type="button"
                              className="flex items-center justify-center transition-transform rounded-full w-7 h-7 bg-white/90 backdrop-blur shadow hover:bg-white hover:scale-110 active:scale-95"
                              onClick={(e) => {
                                e.preventDefault();
                                if (!accessToken) {
                                  setIsLoginModalOpen(true);
                                  return;
                                }
                                if (property.is_favorite) removeFromFavorites(property.favorite_id);
                                else addToFavorites(property._id);
                              }}
                            >
                              <Heart
                                size={14}
                                color={property.is_favorite ? "#e11d48" : "#7a1235"}
                                fill={property.is_favorite ? "#e11d48" : "transparent"}
                                strokeWidth={2}
                              />
                            </button>
                          </div>

                          {total > 1 && (
                            <div className="absolute z-10 flex gap-1 pointer-events-none bottom-2 left-1/2 -translate-x-1/2">
                              {Array.from({ length: total }).map((_, i) => (
                                <span
                                  key={i}
                                  className="h-1 rounded-full transition-all duration-300"
                                  style={{
                                    width: i === active ? "12px" : "5px",
                                    background: i === active ? "#e3b23c" : "rgba(255,255,255,0.6)",
                                  }}
                                />
                              ))}
                            </div>
                          )}
                        </div>

                        {/* Details Box */}
                        <div
                          className={`flex flex-col flex-1 min-h-0 gap-2 p-3 bg-white rounded-xl border transition-colors duration-300 ${
                            isHovered ? "border-[#7a1235] shadow-md" : "border-[#eadfd6] shadow-sm"
                          }`}
                        >
                          <div className="min-w-0">
                            <div className="flex items-start justify-between gap-2">
                              <Link
                                to={`/propertydetails/${property._id}`}
                                className="min-w-0 no-underline hover:no-underline"
                              >
                                <h3 className="m-0 text-sm font-semibold leading-snug text-gray-900 truncate hover:text-[#7a1235] transition-colors">
                                  {property.property_name}
                                </h3>
                              </Link>
                              <button
                                type="button"
                                className="p-1 -mt-0.5 text-[#7a1235] rounded-md hover:bg-[#fbf3ec] transition-colors shrink-0"
                                onClick={() =>
                                  openShareModal(
                                    `${window.location.origin}/property/${property._id}`,
                                  )
                                }
                              >
                                <FontAwesomeIcon icon={faShareNodes} className="text-xs" />
                              </button>
                            </div>

                            {/* Location: maroon marker icon */}
                            <p className="flex items-center gap-1 mt-0.5 mb-0 text-[11px] text-gray-500">
                              <FaMapMarkerAlt className="w-3 h-3 shrink-0 text-[#7a1235]" />
                              <span className="truncate">
                                {property.address_area || property.address || "No Address Provided"}
                              </span>
                            </p>
                          </div>

                          <div className="flex items-end justify-between gap-2 min-w-0">
                            <div className="flex items-baseline gap-0.5 min-w-0 text-base font-bold text-[#7a1235]">
                              <FaRupeeSign className="text-xs self-center" />
                              <span>
                                {isRentCard
                                  ? formatAmount(property.rent)
                                  : formatAmount(property.property_price)}
                              </span>
                              {isRentCard &&
                                property.rent_duration &&
                                property.rent_duration !== "N/A" && (
                                  <span className="text-[10px] font-medium text-gray-500">
                                    / {property.rent_duration}
                                  </span>
                                )}
                            </div>

                            {(property.bhk_type || property.area_sq || property.furnished_type) && (
                              <div className="flex flex-wrap justify-end gap-1 text-[10px] text-gray-700">
                                {property.bhk_type && (
                                  <span className="flex items-center gap-1 px-1.5 py-0.5 rounded bg-[#fbf3ec]">
                                    <MdOutlineBedroomParent className="text-xs text-[#7a1235]" />
                                    {property.bhk_type}
                                  </span>
                                )}
                                {property.area_sq && (
                                  <span className="flex items-center gap-1 px-1.5 py-0.5 rounded bg-[#fbf3ec]">
                                    <BiArea className="text-xs text-[#7a1235]" />
                                    {property.area_sq} sq ft
                                  </span>
                                )}
                                {property.furnished_type && (
                                  <span className="flex items-center gap-1 px-1.5 py-0.5 rounded bg-[#fbf3ec]">
                                    <FontAwesomeIcon icon={faChair} className="text-[10px] text-[#7a1235]" />
                                    {property.furnished_type}
                                  </span>
                                )}
                              </div>
                            )}
                          </div>

                          {/* Owner */}
                          <div className="flex items-center gap-2 pt-2 mt-auto border-t border-[#eadfd6] min-w-0">
                            <div className="flex items-center justify-center w-6 h-6 overflow-hidden rounded-full shrink-0 bg-[#fbf3ec]">
                              {property.property_owner_image ? (
                                <img
                                  src={`${process.env.REACT_APP_API_URL}/media/${property.property_owner_image}`}
                                  alt="Owner"
                                  className="object-cover w-6 h-6"
                                />
                              ) : (
                                <AiOutlineUser className="text-[#7a1235]" size={14} />
                              )}
                            </div>
                            <div className="flex items-baseline gap-1 min-w-0 text-[11px]">
                              <span className="font-semibold text-gray-900 truncate">
                                {property.connect_to_name}
                              </span>
                              <span className="text-gray-500 truncate">· {property.user_type}</span>
                            </div>
                          </div>

                          {/* Actions */}
                          <div className="grid grid-cols-3 gap-1.5">
                            <button
                              type="button"
                              className="flex items-center justify-center h-8 text-[11px] font-semibold text-white rounded-lg bg-[#7a1235] hover:bg-[#5e0d28] active:scale-95 transition-all"
                              onClick={() => handleContactClick(property)}
                            >
                              Contact
                            </button>
                            <a
                              href={`https://wa.me/91${property.connect_to_no}?text=Hello, I am interested in your property`}
                              target="_blank"
                              rel="noopener noreferrer"
                              onClick={(e) => e.stopPropagation()}
                              className="flex items-center justify-center gap-1 h-8 text-[11px] font-semibold text-white rounded-lg bg-[#25D366] hover:brightness-110 active:scale-95 transition-all"
                            >
                              <FaWhatsapp className="text-sm" />
                              WhatsApp
                            </a>
                            <a
                              href={`tel:${property.connect_to_no}`}
                              onClick={(e) => e.stopPropagation()}
                              className="flex items-center justify-center gap-1 h-8 text-[11px] font-semibold text-[#7a1235] rounded-lg border border-[#7a1235] bg-white hover:bg-[#7a1235] hover:text-white active:scale-95 transition-all"
                            >
                              <FaPhone className="text-xs" />
                              Call
                            </a>
                          </div>
                        </div>
                      </div>
                    );
                  })
                ) : (
                  <div className="py-10 text-center text-gray-700 col-span-full">
                    <p className="m-0">No properties available at the moment.</p>
                  </div>
                )}
              </div>

              {isContactModalOpen && selectedProperty && (
                <ContactDetails
                  fullName={
                    freeViewCount <= 0 && paidViewCount <= 0
                      ? `****${selectedProperty.connect_to_name?.slice(-1) || "N/A"}`
                      : selectedProperty.connect_to_name || "N/A"
                  }
                  mobile={
                    freeViewCount <= 0 && paidViewCount <= 0
                      ? `*******${selectedProperty.connect_to_no?.slice(-3) || "000"}`
                      : selectedProperty.connect_to_no || "N/A"
                  }
                  showUpgradePrompt={showUpgradePrompt}
                  onClose={() => setIsContactModalOpen(false)}
                />
              )}

              {/* Pagination */}
              {totalPages > 1 && (
                <div className="flex items-center justify-center gap-2 mt-8">
                  <button
                    onClick={() => handlePageChange(currentPage - 1)}
                    disabled={currentPage === 1}
                    className={`w-9 h-9 flex items-center justify-center rounded-lg border border-[#eadfd6] bg-white text-[#7a1235] transition-colors hover:bg-[#fbf3ec] ${
                      currentPage === 1 ? "opacity-40 cursor-not-allowed" : ""
                    }`}
                  >
                    <MdOutlineNavigateBefore className="text-xl" />
                  </button>
                  {getPaginationRange().map((page, index) => (
                    <button
                      key={index}
                      onClick={() => (page !== "..." ? handlePageChange(page) : null)}
                      className={`min-w-[36px] h-9 px-2 text-sm rounded-lg flex items-center justify-center transition-colors ${
                        currentPage === page
                          ? "bg-[#7a1235] text-white font-semibold"
                          : "text-gray-700 hover:bg-[#fbf3ec]"
                      }`}
                    >
                      {page}
                    </button>
                  ))}
                  <button
                    onClick={() => handlePageChange(currentPage + 1)}
                    disabled={currentPage === totalPages}
                    className={`w-9 h-9 flex items-center justify-center rounded-lg border border-[#eadfd6] bg-white text-[#7a1235] transition-colors hover:bg-[#fbf3ec] ${
                      currentPage === totalPages ? "opacity-40 cursor-not-allowed" : ""
                    }`}
                  >
                    <MdOutlineNavigateNext className="text-xl" />
                  </button>
                </div>
              )}
            </div>

            {/* Map */}
            <div className="sticky top-0 w-full p-3 sm:w-3/4 md:w-1/2 lg:w-[500px] h-[300px] sm:h-screen sm:self-start">
              <div className="relative w-full h-full overflow-hidden bg-[#fbf3ec] border border-[#eadfd6] rounded-xl zb-map">
                {loading ? (
                  <div className="flex items-center justify-center w-full h-full gap-3 text-[#7a1235]">
                    <span className="w-5 h-5 border-2 rounded-full border-[#7a1235] border-t-transparent animate-spin" />
                    <p className="m-0 text-sm font-medium">Loading properties...</p>
                  </div>
                ) : (
                  <>
                    <div className="absolute z-[1000] px-3 py-1.5 text-xs font-semibold text-white rounded-lg shadow-md pointer-events-none bottom-3 left-3 bg-[#7a1235]">
                      {validProperties.length} properties on map
                    </div>
                    <MapContainer
                      center={mapCenter}
                      zoom={12}
                      scrollWheelZoom={false}
                      style={{ width: "100%", height: "100%" }}
                    >
                      <TileLayer url={TILE_URL} />
                      <MapPanner target={panTarget} />

                      {validProperties.map((property) => (
                        <Marker
                          key={property._id}
                          position={[parseFloat(property.latitude), parseFloat(property.longitude)]}
                          icon={createCustomIcon(
                            getListedPrice(property),
                            isMarkerActive(property._id),
                          )}
                          zIndexOffset={isMarkerActive(property._id) ? 1000 : 0}
                          eventHandlers={{
                            mouseover: () => setHoveredPropertyId(property._id),
                            mouseout: () => setHoveredPropertyId(null),
                          }}
                        >
                          <Popup className="zb-popup" minWidth={220} maxWidth={260}>
                            <div className="w-[220px] sm:w-[240px] relative bg-white p-2">
                              <div className="relative h-[120px] mb-2 rounded-lg overflow-hidden bg-slate-900">
                                <img
                                  src={property.cover_image}
                                  alt="Property"
                                  className="object-cover w-full h-full"
                                />
                              </div>
                              <div className="text-xs font-bold text-[#7a1235]">
                                {formatPrice(getListedPrice(property))}
                              </div>
                              <div className="font-semibold text-gray-800 truncate text-xs mt-0.5">
                                {property.property_name}
                              </div>
                              <div className="text-[11px] text-gray-500 truncate">
                                {property.address}
                              </div>
                            </div>
                          </Popup>
                        </Marker>
                      ))}
                    </MapContainer>
                  </>
                )}
              </div>
            </div>

            {isShareModalOpen && (
              <div className="absolute right-0 z-50">
                <ShareModal
                  currentShareUrl={currentShareUrl}
                  closeShareModal={handleCloseShareModal}
                  copyLink={copyShareLink}
                />
              </div>
            )}
          </div>
        </div>

        <Login1
          isOpen={isLoginModalOpen}
          onClose={() => setIsLoginModalOpen(false)}
          onSwitchToSignUp={() => {
            setIsLoginModalOpen(false);
            setIsSignUpModalOpen(true);
          }}
        />
        <SignUp1
          isOpen={isSignUpModalOpen}
          onClose={() => setIsSignUpModalOpen(false)}
          onSwitchToLogin={() => {
            setIsSignUpModalOpen(false);
            setIsLoginModalOpen(true);
          }}
        />
      </div>
    </>
  );
}